<template>
 

 <div>
 


<div  v-if='loutbox' style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 10000000;" class="d-flex align-items-center justify-content-center p-3">

 <div v-on:click='loutbox=false'   style="position:absolute;top:0;left: 0;right: 0;bottom: 0;background: rgba(0, 0, 0, 0.5); ;"  >    </div>
      
      <div style="width:300px;padding:20px;border-radius:10px;background:#fff;position: relative;z-index: 10000;">
        <p style="text-align:center;font-weight: 500;font-size: 15px;color: rgb(32, 34, 43);">Are you sure?</p>
        <div class="d-flex align-items-center mt-3">
          <div style="flex:1;padding-right: 10px;">
            <div style="    color: rgb(102, 106, 114);box-shadow: rgb(212 216 225) 0px 0px 0px 1px inset;font-weight: 500;text-align: center;font-size: 13px;border-radius: 5px;padding: 6px 0px;cursor: pointer;" v-on:click='loutbox=false'>
              Cancel
            </div>
          </div>
           <div style="flex:1;padding-right: 10px;">
            <div style=" background: rgb(224, 71, 95);   color: #fff;font-weight: 500;text-align: center;font-size: 13px;border-radius: 5px;padding: 6px 0px;cursor: pointer;" v-on:click='lout'>
            Confirm
            </div>
          </div>
        </div>
      </div>


  </div>





<div v-if='delbox' style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 10000000;" class="d-flex align-items-center justify-content-center p-3">
  <div v-on:click='delbox=false' style="position:absolute;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0, 0, 0, 0.5);"></div>
  <div style="width: 450px; padding: 30px;border-radius: 10px;background:#fff;position: relative;z-index: 1000;">
    <div>
      

      <div class="d-flex align-items-center">
        <div style="width:40px;height:40px;border-radius:5px;background:rgba(224, 71, 95, 0.2)" class="d-flex align-items-center justify-content-center">
          <i class='bx bxs-trash-alt' style="font-size:20px;color:rgb(224, 71, 95)" ></i>
        </div>
        <h2 style="margin-bottom:0px;margin-left:20px;color: rgb(32, 34, 43);font-weight:400;font-size: 18px">Delete this project?</h2>
      </div>
<p style="font-weight:300;font-size: 15px;color: rgb(43, 47, 59);" class="mt-3">Are you sure you want to delete this project?</p>
      <div class="d-flex align-items-end justify-content-end  mt-4">
                <div v-on:click='delbox=false' style="background:#fff;padding:6px 13px;border-radius:5px;color: rgb(102, 106, 114);font-weight: 500;font-size:14px;border:1px solid #999;margin-right: 20px;cursor: pointer;">Cancel</div>

        <div style="background:rgb(212, 67, 90);padding:6px 13px;border-radius:5px;color: #fff;font-weight: 500;font-size:14px;cursor: pointer;" v-on:click='delpro'>Delete</div>
      </div>
 
    </div>  
  </div>

</div>




<div v-if='levbox' style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 10000000;" class="d-flex align-items-center justify-content-center p-3">
  <div v-on:click='levbox=false' style="position:absolute;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0, 0, 0, 0.5);"></div>
  <div style="width: 450px; padding: 30px;border-radius: 10px;background:#fff;position: relative;z-index: 1000;">
    <div>
      

      <div class="d-flex align-items-center">
        <div style="width:40px;height:40px;border-radius:5px;background:#FBE4D4" class="d-flex align-items-center justify-content-center">
          <i class='bx bxs-trash-alt' style="font-size:20px;color:rgb(234, 112, 4)" ></i>
        </div>
        <h2 style="margin-bottom:0px;margin-left:20px;color: rgb(32, 34, 43);font-weight:400;font-size: 18px">Leave the project?</h2>
      </div>
<p style="font-weight:300;font-size: 15px;color: rgb(43, 47, 59);" class="mt-3">Are you sure you want to leave <span style="font-weight:500">{{proname}}</span> This project is shared with you and will not be visible once you leave.</p>
      <div class="d-flex align-items-end justify-content-end  mt-4">
                <div v-on:click='levbox=false' style="background:#fff;padding:6px 13px;border-radius:5px;color: rgb(102, 106, 114);font-weight: 500;font-size:14px;border:1px solid #999;margin-right: 20px;cursor: pointer;">Cancel</div>

        <div style="background:#0BAB7D;padding:6px 13px;border-radius:5px;color: #fff;font-weight: 500;font-size:14px;cursor: pointer;border: 1px solid #0BAB7D;" v-on:click='levpro'>Leave</div>
      </div>
 
    </div>  
  </div>

</div>



<div style="position:fixed;top:0;left: 0;right: 0;z-index: 10000000;"  v-if='copylink'class="d-flex justify-content-center topm20 p-3">
  <div  :class="{alertbox:true,act:copylink}" style="">
    <i style="color:#39D7AA;font-size: 24px;margin-right: 10px;" class='bx bxs-check-circle' ></i>
    <p style="font-size:15px;color: #f1f1f1;margin-bottom: 0px;font-weight: 500;">Link Copied!</p>
  </div>
</div>


<div style="position:fixed;top:0;left: 0;right: 0;z-index: 10000000;" v-if='copylink' class="d-flex justify-content-center topm20">
  <div  :class="{alertbox:true,act:acceptlink}" style="">
    <i style="color:#39D7AA;font-size: 24px;margin-right: 10px;" class='bx bxs-check-circle' ></i>
    <p style="font-size:15px;color: #f1f1f1;margin-bottom: 0px;font-weight: 500;">Invite accepted successfully</p>
  </div>
</div>

<!--
<div v-if='addboxproject' style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 10000000;" class="d-flex align-items-center justify-content-center">
  <div v-on:click='addboxproject=false' style="position:absolute;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0,0,0,0.1);"></div>
  <div style="width: 450px;box-shadow: 0 4px 10px rgb(32, 34, 43);padding: 30px;border-radius: 10px;background:#fff;position: relative;z-index: 1000;">
    <div>
      <h2 style="font-size:19px;font-weight: 500;color: #20222b;">Add Project</h2>
      <form v-on:submit.prevent='addproject'>
        <div class="mt-4">
          <p style="font-size:15px;color:#999;font-weight:400;margin-bottom: 10px;">Project Name</p>
          <input v-model='projectname'  required type="text" class="form-control" name="">
        </div>
        <button  style="background:#303247;color: #fff;font-size: 13px;font-weight: 500;text-align: center;border-radius: 3px;text-transform: uppercase;letter-spacing: 0.4px;outline: none;display: block;width: 100%;box-shadow: none;border:none" class="mt-4 py-2">
          Add Project
        </button>
        <div style="text-align:center;" v-if='loadstarted'>
          <img src="../images/loading.gif" style="width:50px;">
        </div>
        
      </form>
    </div>  
  </div>

</div>



-->


<div v-if='addboxproject' style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 10000000;" class="d-flex align-items-center justify-content-center p-3">
  <div v-on:click='addboxproject=false' style="position:absolute;top: 0;left: 0;right: 0;bottom: 0;background:rgba(0, 0, 0, 0.5);"></div>
  <div style="width: 450px;box-shadow: 0 4px 10px rgb(32, 34, 43);padding: 0px;border-radius: 10px;background:#fff;position: relative;z-index: 1000;overflow: hidden;">
    <div style="padding:15px 20px;background: #0BAB7D;" class="d-flex align-items-center justify-content-between">
      <p style="color:#fff;font-weight:500;font-size: 18px;margin-bottom: 0px;">Add Project</p>
      <i class='bx bx-x' v-on:click='addboxproject=false' style="font-size:30px;color: #fff;cursor: pointer;" ></i>
    </div>
    <div style="padding:20px">
       <form v-on:submit.prevent='addproject'>
        <div class=" ">
          <p style="font-size:15px;color:#999;font-weight:400;margin-bottom: 10px;">Project Name</p>
          <input v-model='projectname'  required type="text" id="addpros"  class="form-control" autofocus  style="border:1px solid #d7dbde;background: #eee!important;outline: none!important;box-shadow: none!important;" name="">
        </div>
        <div style="text-align:right;">
           <button  style="background:#2d313e;color: #fff;font-size: 13px;font-weight: 500;text-align: center;border-radius: 3px;text-transform: uppercase;letter-spacing: 0.4px;outline: none;  box-shadow: none;border:none;padding: 10px 20px;" class="mt-4  ">
          Save changes
        </button>
        </div>
       
        <div style="text-align:center;" v-if='false'>
          <img src="../images/loading.gif" style="width:50px;">
        </div>
        
      </form>
    </div>  
  </div>

</div>





<div v-if='invbox' style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 10000000;" class="d-flex align-items-center justify-content-center p-3">
  <div v-on:click='invbox=false' style="position:absolute;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0, 0, 0, 0.5)"></div>
  <div style="width: 450px;box-shadow: 0 4px 10px rgb(32, 34, 43);padding: 25px;border-radius: 10px;background:#fff;position: relative;z-index: 1000;overflow: hidden;">
    <div v-if='rmbox' style="position:absolute;top:0;left: 0;right: 0;bottom: 0;background: rgba(0,0,0,0.1);z-index: 10000000;" class="d-flex align-items-center justify-content-center">
      
      <div style="width:250px;padding:20px;border-radius:10px;background:#fff">
        <p style="text-align:center;font-weight: 500;font-size: 13px;color: rgb(32, 34, 43);">Remove from project?</p>
        <div class="d-flex align-items-center mt-3">
          <div style="flex:1;padding-right: 10px;">
            <div style="    color: rgb(102, 106, 114);box-shadow: rgb(212 216 225) 0px 0px 0px 1px inset;font-weight: 500;text-align: center;font-size: 13px;border-radius: 5px;padding: 6px 0px;cursor: pointer;" v-on:click='rmbox=false'>
              Cancel
            </div>
          </div>
           <div style="flex:1;padding-right: 10px;">
            <div style=" background: rgb(224, 71, 95);   color: #fff;font-weight: 500;text-align: center;font-size: 13px;border-radius: 5px;padding: 6px 0px;cursor: pointer;" v-on:click='rmconf'>
              Remove
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-between">
      <h2 style="color:#21232c;font-size: 16px;font-weight: 500;;margin-bottom:0px">Project Members</h2>


      <div class="d-none align-items-center">
        <p style="font-size:12px;color:#666a72;font-weight:300;margin-bottom:0px">Invite via link</p>
        <i class='bx bx-link-alt'  style="font-size:20px;color:#b8c1cf;font-weight:500;margin-left:5px"></i>
      </div>
       <div class="d-flex align-items-center">
       
        <i class='bx bxs-group'  style="font-size:20px;color:#b8c1cf;font-weight:500;margin-right:5px"></i>
         <p style="font-size:12px;color:#666a72;font-weight:300;margin-bottom:0px">Total Members ({{currentdata.members.length}})</p>
      </div>
    </div>
    
    <div style="padding:0px;max-height:300px" class="d-flex flex-column"> 
        <div class="mt-3">
           <input v-model='invtext' v-on:keyup.enter='invitemem'    type="text"   class="form-control invform" autofocus  style="border:1px solid rgb(227, 230, 236);background: #fff!important;outline: none!important;box-shadow: none!important;color: rgb(32, 34, 43);font-size: 13px;font-weight: 400;height: 40px;" placeholder="Invite by email or search for name" name="">
        </div>

 
        <div class=" invsrc" :style="{'display':invtext!='' && alleteam.length==0  ?'flex':'none'}">
          <div style=" " class="mailmain d-flex align-items-center justify-content-center">
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M11.65 12.652l8.15-4.567a.829.829 0 0 1 1.102.308c.22.379.092.86-.289 1.086l-8.372 4.692a.831.831 0 0 1-.592.085.831.831 0 0 1-.592-.085L2.686 9.478a.8.8 0 0 1-.43-.697.8.8 0 0 1 .413-.706.834.834 0 0 1 .83.009l8.151 4.567zM2.272 7.17c0-.64.26-1.252.723-1.703a2.48 2.48 0 0 1 1.741-.7h14.196c1.356 0 2.457 1.075 2.464 2.404v9.643c0 .64-.26 1.252-.723 1.703a2.48 2.48 0 0 1-1.741.701H4.737c-1.356-.001-2.457-1.075-2.464-2.404V7.17zm1.64 0v9.645c0 .432.372.797.824.797h14.196a.824.824 0 0 0 .582-.23.79.79 0 0 0 .243-.568V7.172a.82.82 0 0 0-.825-.799H4.737a.824.824 0 0 0-.582.23.79.79 0 0 0-.243.569V7.17z" fill="rgb(125, 130, 156)"></path></svg>
          </div>
          <div style="padding-left:20px;cursor:pointer;" v-on:click='invitemem'>
            <p style="color:rgb(32, 34, 43);font-size: 13px;font-weight: 400;margin-bottom: 0px;">{{invtext}}</p>

            <p v-if="!invtext.includes('@')" style="color: rgb(125, 130, 156);font-size: 12px;font-weight: 400;margin-bottom: 0px;">Keep typing!</p>
            <p v-if="invtext.includes('@')" style="color: rgb(125, 130, 156);font-size: 12px;font-weight: 400;margin-bottom: 0px;">Invite {{invtext}} to this project </p>
          </div>
        </div> 


<div  :style="{'display':invtext!='' && alleteam.length>0  ?'block':'none'}">
        <template v-for='itm in  alleteam'>
            <div class="d-flex align-items-center py-2  aprr"  style="position:relative;cursor: pointer!important;" v-on:click='addteammem(itm)'>
                 
                 <div  :style="{background:itm.memberinfo.color}" class="d-flex align-items-center justify-content-center log">
           <span style="font-size:14px;font-weight:500;color:#fff;text-transform: uppercase!important;user-select: none!important;">{{itm.memberinfo.name[0]}}</span>
         </div>
         <div class="  " style="margin-left: 20px;">
           <p style="margin-bottom:2px;color: rgb(32, 34, 43);font-weight:400;font-size:14px">{{itm.memberinfo.name}}</p>
            <p  style="margin-bottom:0px;color: rgb(125, 130, 156);font-weight:400;font-size:13px">{{itm.memberinfo.email}}</p>
         </div>
               </div>

 
        </template>
</div>
       




        <p style="color:rgb(102, 106, 114);font-weight: 400;font-size: 14px;" class="mt-4 mb-2">Peoples in this project</p>
         <div style="height: 300px;overflow: scroll;">
            <template v-for='itm in  currentdata.members'>
              <div class="d-flex align-items-center py-2  aprr" v-if='itm.active' style="position:relative;cursor: pointer!important;">
                 
                 <div  :style="{background:itm.memberinfo.color}" class="d-flex align-items-center justify-content-center log">
           <span style="font-size:14px;font-weight:500;color:#fff;text-transform: uppercase!important;user-select: none!important;">{{itm.memberinfo.name[0]}}</span>
         </div>
         <div class="  " style="margin-left: 20px;">
           <p style="margin-bottom:2px;color: rgb(32, 34, 43);font-weight:400;font-size:14px">{{itm.memberinfo.name}}</p>
            <p  style="margin-bottom:0px;color: rgb(125, 130, 156);font-weight:400;font-size:13px">{{itm.memberinfo.email}}</p>
         </div>
           <p  style="margin-bottom:0px;color: rgb(102, 106, 114);font-weight:400;font-size:13px;margin-left:auto;opacity: 0.5;" v-if='itm.active'>Member</p>
         <i class='bx bx-x aprrx' v-on:click='remmem(itm)' style="font-size:20px; margin-left: 10px;color: rgb(102, 106, 114);" ></i>
              </div>


                <div class="d-flex align-items-center py-2 " v-else>
                 <div   style="color:#222;background:#D4D8E1" class="d-flex align-items-center justify-content-center log">
           <span style="font-size:14px;font-weight:500;color:#222;text-transform: uppercase!important;user-select: none!important;">{{itm.email[0]}}</span>
                       <p  style="margin-bottom:0px;color: rgb(125, 130, 156);font-weight:400;font-size:13px">{{itm.memberinfo.email}}</p>

         </div>
         <div class="  " style="margin-left: 20px;">
          
                        <p style="margin-bottom:2px;color: rgb(32, 34, 43);font-weight:400;font-size:14px">{{itm.email}}</p>

                        <p  style="margin-bottom:0px;color: rgb(125, 130, 156);font-weight:400;font-size:13px">Pending</p>

         </div>
               </div>
            </template>
         </div>
    </div>  
  </div>

</div>




<div v-if='editprobox' style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 10000000;" class="d-flex align-items-center justify-content-center p-3">
  <div v-on:click='editprobox=false' style="position:absolute;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0, 0, 0, 0.5)"></div>
  <div style="width: 450px;box-shadow: 0 4px 10px rgb(32, 34, 43);padding: 0px;border-radius: 10px;background:#fff;position: relative;z-index: 1000;overflow: hidden;">
    <div style="padding:15px 20px;background: #0BAB7D;" class="d-flex align-items-center justify-content-between">
      <p style="color:#fff;font-weight:500;font-size: 18px;margin-bottom: 0px;">Edit Project</p>
      <i class='bx bx-x' v-on:click='editprobox=false'  style="font-size:30px;color: #fff;cursor: pointer;" ></i>
    </div>
    <div style="padding:20px">
       <form v-on:submit.prevent='editproject'>
        <div class=" ">
          <p style="font-size:15px;color:#999;font-weight:400;margin-bottom: 10px;">Project Name</p>
          <input v-model='projectnames'  required type="text" class="form-control" autofocus  style="border:1px solid #d7dbde;background: #eee!important;outline: none!important;box-shadow: none!important;" name="">
        </div>
        <div style="text-align:right;">
           <button  style="background:#2d313e;color: #fff;font-size: 13px;font-weight: 500;text-align: center;border-radius: 3px;text-transform: uppercase;letter-spacing: 0.4px;outline: none;  box-shadow: none;border:none;padding: 10px 20px;" class="mt-4  ">
          Save changes
        </button>
        </div>
       
        <div style="text-align:center;" v-if='loadstarted'>
          <img src="../images/loading.gif" style="width:50px;">
        </div>
        
      </form>
    </div>  
  </div>

</div>
 

   <div class="container-fluid" style="overflow: hidden;">
     <div class="row">
       <div class="col-md-2" style="">
        
         <div style=""  class="leftbox">
           
           <div class="d-flex align-items-center">
             <div    style="width:35px;border-radius:5px;overflow:hidden">
               <img  src="https://firebasestorage.googleapis.com/v0/b/staging-wlshop.appspot.com/o/websitelearners_logo_790924.png?alt=media&token=aaa8373b-30af-431a-9ae4-8550d79fb07b" style="width:100%">
             </div>
             <h2 id="d" style="font-size:17px;font-weight:400;color:#EFF1F5;margin-bottom:0px;margin-left:10px" >Website Learners</h2>
             
             
           </div>

        

         
           <div class="mt-4" style="position:relative">
           

       
                <div  v-on:click='setaddpro' style="position:absolute;top:2px;right:10px;width:24px;height:24px;border-radius:50%;background: #20222B;z-index:1;cursor:pointer" class="d-flex align-items-center justify-content-center shp">
                   <i class='bx bx-plus ' style=' color:#7D829C;font-size:19px;transition: all 0.4s;'   ></i>


                </div>

             <p style="color:#7d829c;font-size:15px;font-weight:500;cursor:pointer;position:relative;user-select: none;" v-on:click='foldervisible=!foldervisible'>

              <div :class='{trans:!foldervisible}' style="transition: all 0.5s;display: inline-block;vertical-align:middle;margin-right:2px;cursor: pointer;"  v-on:click='foldervisible=!foldervisible'>
               <i class='bx bx-chevron-down' style="font-size:20px;color:#7d829c;"  ></i>
              </div>

              <span style="color: rgb(125, 130, 156);font-size: 14px;;cursor: pointer;user-select: none;" v-on:click='foldervisible=!foldervisible'>Projects</span>    
                 
             </p>

           </div>

       
           <div style="padding-left:0px" class="mt-3" v-if='foldervisible && !load' >
 
 


            <template v-for='(itm,index) in leftsides'>
              <div   style="color:#b8c1cf;font-size:15px;font-weight:400;position:relative;cursor:pointer;background: #20222B;margin-left: 0px;padding-left: 28px;border-radius: 4px;cursor: pointer" class="py-2 projects d-flex align-items-center" v-if='itm.selected'>
 

                <span style=" flex: 1;margin-right: 10px;position: relative;overflow: hidden;" class="maintexts" v-on:click="getdatas(itm)">
                  <span style="flex: 1;overflow:hidden; display: block;white-space: nowrap; text-overflow: ellipsis; color: #fff;font-size: 13px">{{itm.name}} </span>

                </span>

                <div class="submaintexts " style="  position: absolute;top: 100%; left:50%; display: none;padding-top: 0px;cursor: pointer;z-index: 1000000;    width: max-content; max-width: 300px; ">

                <h2 class="" style="position: relative;font-size: 10px;font-weight:300;color: #EFF1F5;margin-bottom: 0px;margin-left: 0px; padding: 3px;background:#323744;border-radius: 5px;opacity: 1; width:auto "  >{{itm.name}}
               </h2>


              </div>

 
                <i class=' bx bx-dots-vertical-rounded' v-on:click='itm.selectedright=!itm.selectedright' style=" color:#fff;font-size: 23px;margin-right: 10px;" ></i>


 
<div style="position:fixed;top:0;left: 0;right: 0;bottom: 0;" v-if='itm.selectedright' v-on:click='itm.selectedright=!itm.selectedright'  ></div>
              <div   :class="{'pops':true,'actpop':itm.selectedright}" style=" z-index: 10000;">
                 <div class="d-flex align-items-center px-2 py-2 bord" style="border-radius: 6px;" v-on:click='seteditpro(itm)'>
    <i class='bx bx-cog' style="color:#666a72;font-size:20px;margin-right: 8px;" ></i>
    <p style="color:rgb(32, 34, 43);font-size:15px;font-weight: 500;">Settings</p>
  </div>

    <div v-if='email==itm.createdby.email' class="d-flex align-items-center px-2 py-2 bord" style="border-radius: 6px;" v-on:click='setdelpro(itm)'>
    <i class='bx bx-trash' style="color:#666a72;font-size:20px;margin-right: 8px;" ></i>
    <p style="color:rgb(32, 34, 43);font-size:15px;font-weight: 500;margin-bottom: 0px;transform: translateY(2px);">Delete</p>
  </div>

    <div  class="d-flex align-items-center px-2 py-2 bord" style="border-radius: 6px;" v-on:click='setlevpro(itm)'>
 
    <i class='bx bx-log-in'   style="color:#666a72;font-size:20px;margin-right: 8px;"></i>
    <p style="color:rgb(32, 34, 43);font-size:15px;font-weight: 500;">Leave Project</p>
  </div>
  </div>


</div>
              <div  style="color:#b8c1cf;font-size:15px;font-weight:400;position:relative;cursor:pointer;margin-left: 0px;padding-left: 28px;border-radius: 4px;cursor: pointer;" class="py-2 projects d-flex align-items-center" v-else>      

                


                <span v-on:click="getdatas(itm)" style=" flex: 1;margin-right: 10px;position: relative;overflow: hidden;" class="maintexts">
                  <span style="flex: 1;overflow:hidden; display: block;white-space: nowrap; text-overflow: ellipsis; color: rgb(184, 193, 207);font-size: 13px"> {{itm.name}} </span>

                </span>

                <div class="submaintexts " style="  position: absolute;top: 100%; left:50%; display: none;padding-top: 0px;cursor: pointer;z-index: 1000000;    width: max-content; max-width: 300px; ">

                <h2 class="" style="position: relative;font-size: 10px;font-weight:300;color: #EFF1F5;margin-bottom: 0px;margin-left: 0px; padding: 3px;background:#323744;border-radius: 5px;opacity: 1; width:auto "  >{{itm.name}}
               </h2>


              </div>

 
                <i class=' bx bx-dots-vertical-rounded' v-on:click='itm.selectedright=!itm.selectedright' style=" color:rgb(184, 193, 207);font-size: 23px;margin-right: 10px;" ></i>





 <div style="position:fixed;top:0;left: 0;right: 0;bottom: 0;" v-if='itm.selectedright' v-on:click='itm.selectedright=!itm.selectedright'  ></div>
              <div   :class="{'pops':true,'actpop':itm.selectedright}" style=" z-index: 10000;">
                 <div class="d-flex align-items-center px-2 py-2 bord" style="border-radius: 6px;" v-on:click='seteditpro(itm)'>
    <i class='bx bx-cog' style="color:#666a72;font-size:20px;margin-right: 8px;" ></i>
    <p style="color:rgb(32, 34, 43);font-size:15px;font-weight: 500;">Settings</p>
  </div>
    <div v-if='email==itm.createdby.email' class="d-flex align-items-center px-2 py-2 bord" style="border-radius: 6px;" v-on:click='setdelpro(itm)'>
    <i class='bx bx-trash' style="color:#666a72;font-size:20px;margin-right: 8px;" ></i>
    <p style="color:rgb(32, 34, 43);font-size:15px;font-weight: 500;margin-bottom: 0px;transform: translateY(2px);">Delete</p>
  </div>
    <div class="d-flex align-items-center px-2 py-2 bord" style="border-radius: 6px;">
 
    <i class='bx bx-log-in'   style="color:#666a72;font-size:20px;margin-right: 8px;"></i>
    <p style="color:rgb(32, 34, 43);font-size:15px;font-weight: 500;">Leave Project</p>
  </div>
  </div>
              </div>
            </template>
              
           </div>
         </div> 





<div style="position:fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 10000000;" v-if='lboxstatus' v-on:click='lboxstatus=false'></div>
<div   :class="{'leftboxmob':true,'trass':lboxstatus}" v-on:click='lboxstatus=false'>
           
           <div class="d-flex align-items-center">
             <div    style="width:35px;border-radius:5px;overflow:hidden">
               <img  src="https://firebasestorage.googleapis.com/v0/b/staging-wlshop.appspot.com/o/websitelearners_logo_790924.png?alt=media&token=aaa8373b-30af-431a-9ae4-8550d79fb07b" style="width:100%">
             </div>
             <h2 id="d" v-on:click='tests' style="font-size:17px;font-weight:400;color:#EFF1F5;margin-bottom:0px;margin-left:10px" >Website Learners</h2>
             
             
           </div>

        

         
           <div class="mt-4" style="position:relative">
           

                <div  v-on:click='setaddpro' style="position:absolute;top:2px;right:10px;width:24px;height:24px;border-radius:50%;background: #20222B;z-index:1;cursor:pointer" class="d-flex align-items-center justify-content-center shp">
                   <i class='bx bx-plus ' style=' color:#7D829C;font-size:19px;transition: all 0.4s;'   ></i>


                </div>

             <p style="color:#7d829c;font-size:15px;font-weight:500;cursor:pointer;position:relative;user-select: none;" v-on:click='foldervisible=!foldervisible'>

              <div :class='{trans:!foldervisible}' style="transition: all 0.5s;display: inline-block;vertical-align:middle;margin-right:2px;cursor: pointer;"  v-on:click='foldervisible=!foldervisible'>
               <i class='bx bx-chevron-down' style="font-size:20px;color:#7d829c;"  ></i>
              </div>

              <span style="color: rgb(125, 130, 156);font-size: 14px;;cursor: pointer;user-select: none;" v-on:click='foldervisible=!foldervisible'>Projects</span>    
                 
             </p>

           </div>
           <div style="padding-left:0px" class="mt-3" v-if='foldervisible'>
            <template v-for='(itm,index) in leftsides'>
              <div  v-on:click="getdatas(itm)" style="color:#b8c1cf;font-size:15px;font-weight:400;position:relative;cursor:pointer;background: #20222B;margin-left: 25px;padding-left: 20px;border-radius: 4px;cursor: pointer" class="py-2 projects d-flex align-items-center" v-if='itm.selected'>
 

                <span style=" flex: 1;margin-right: 10px;position: relative;overflow: hidden;" class="maintexts">
                  <span style="flex: 1;overflow:hidden; display: block;white-space: nowrap; text-overflow: ellipsis; color: #fff;font-size: 13px"> {{itm.name}} </span>

                </span>

                <div class="submaintexts " style="  position: absolute;top: 100%; left:50%; display: none;padding-top: 0px;cursor: pointer;z-index: 1000000;    width: max-content; max-width: 300px; ">

                <h2 class="" style="position: relative;font-size: 10px;font-weight:300;color: #EFF1F5;margin-bottom: 0px;margin-left: 0px; padding: 3px;background:#323744;border-radius: 5px;opacity: 1; width:auto "  >{{itm.name}}
               </h2>


              </div>

 
                <i class=' bx bx-dots-vertical-rounded' v-on:click='itm.selectedright=!itm.selectedright' style=" color:#fff;font-size: 23px;margin-right: 10px;" ></i>


 
<div style="position:fixed;top:0;left: 0;right: 0;bottom: 0;" v-if='itm.selectedright' v-on:click='itm.selectedright=!itm.selectedright'  ></div>
              <div   :class="{'pops':true,'actpop':itm.selectedright}" style=" z-index: 10000;">
                 <div class="d-flex align-items-center px-2 py-2 bord" style="border-radius: 6px;" v-on:click='seteditpro(itm)'>
    <i class='bx bx-cog' style="color:#666a72;font-size:20px;margin-right: 8px;" ></i>
    <p style="color:rgb(32, 34, 43);font-size:15px;font-weight: 500;">Settings</p>
  </div>

    <div v-if='email==itm.createdby.email' class="d-flex align-items-center px-2 py-2 bord" style="border-radius: 6px;" v-on:click='setdelpro(itm)'>
    <i class='bx bx-trash' style="color:#666a72;font-size:20px;margin-right: 8px;" ></i>
    <p style="color:rgb(32, 34, 43);font-size:15px;font-weight: 500;margin-bottom: 0px;transform: translateY(2px);">Delete</p>
  </div>

    <div  class="d-flex align-items-center px-2 py-2 bord" style="border-radius: 6px;" v-on:click='setlevpro(itm)'>
 
    <i class='bx bx-log-in'   style="color:#666a72;font-size:20px;margin-right: 8px;"></i>
    <p style="color:rgb(32, 34, 43);font-size:15px;font-weight: 500;">Leave Project</p>
  </div>
  </div>


</div>
              <div  v-on:click="getdatas(itm)" style="color:#b8c1cf;font-size:15px;font-weight:400;position:relative;cursor:pointer;margin-left: 25px;padding-left: 20px;border-radius: 4px;cursor: pointer;" class="py-2 projects d-flex align-items-center" v-else>      

                


                <span style=" flex: 1;margin-right: 10px;position: relative;overflow: hidden;" class="maintexts">
                  <span style="flex: 1;overflow:hidden; display: block;white-space: nowrap; text-overflow: ellipsis; color: rgb(184, 193, 207);font-size: 13px">{{itm.name}} </span>

                </span>

                <div class="submaintexts " style="  position: absolute;top: 100%; left:50%; display: none;padding-top: 0px;cursor: pointer;z-index: 1000000;    width: max-content; max-width: 300px; ">

                <h2 class="" style="position: relative;font-size: 10px;font-weight:300;color: #EFF1F5;margin-bottom: 0px;margin-left: 0px; padding: 3px;background:#323744;border-radius: 5px;opacity: 1; width:auto "  >{{itm.name}}
               </h2>


              </div>

 
                <i class=' bx bx-dots-vertical-rounded' v-on:click='itm.selectedright=!itm.selectedright' style=" color:rgb(184, 193, 207);font-size: 23px;margin-right: 10px;" ></i>





 <div style="position:fixed;top:0;left: 0;right: 0;bottom: 0;" v-if='itm.selectedright' v-on:click='itm.selectedright=!itm.selectedright'  ></div>
              <div   :class="{'pops':true,'actpop':itm.selectedright}" style=" z-index: 10000;">
                 <div class="d-flex align-items-center px-2 py-2 bord" style="border-radius: 6px;" v-on:click='seteditpro(itm)'>
    <i class='bx bx-cog' style="color:#666a72;font-size:20px;margin-right: 8px;" ></i>
    <p style="color:rgb(32, 34, 43);font-size:15px;font-weight: 500;">Settings</p>
  </div>
    <div v-if='email==itm.createdby.email' class="d-flex align-items-center px-2 py-2 bord" style="border-radius: 6px;" v-on:click='setdelpro(itm)'>
    <i class='bx bx-trash' style="color:#666a72;font-size:20px;margin-right: 8px;" ></i>
    <p style="color:rgb(32, 34, 43);font-size:15px;font-weight: 500;margin-bottom: 0px;transform: translateY(2px);">Delete</p>
  </div>
    <div class="d-flex align-items-center px-2 py-2 bord" style="border-radius: 6px;">
 
    <i class='bx bx-log-in'   style="color:#666a72;font-size:20px;margin-right: 8px;"></i>
    <p style="color:rgb(32, 34, 43);font-size:15px;font-weight: 500;">Leave Project</p>
  </div>
  </div>
              </div>
            </template>
              
           </div>
         </div> 



       </div>

<div v-if='load' class="cuswidth ">
      <div style="height: 100vh;" class="mobcons">
    <img src="../assets/loader.gif" style="width:100px ">
  </div>
</div>

         <div class="cuswidth" v-else-if='leftsides.length==0 && !load' style='padding:0px'>
            <div class="d-flex align-items-center justify-content-center" style="height: 100vh;position: relative;">


                 <div class="d-flex align-items-center justify-content-between" style="position:absolute;left: 0;right: 0;top: 0;z-index: 10000000000;padding: 30px;">
             <div style="position:relative; ">
                
 


         </div>


<div style="position:fixed;top:0;left: 0;right: 0;bottom: 0;z-index: 10000;cursor: pointer; " v-if='logbox'  v-on:click="logbox=false"></div>

         <div v-if='userdataloaded' :style="{background:userinfo.color}" v-on:click="logbox=!logbox" class="d-flex align-items-center justify-content-center log">
           <span style="font-size:14px;font-weight:500;color:#fff;text-transform: uppercase!important;user-select: none!important;">{{userinfo.name[0]}}</span>
           <div style="" class="logsub" v-if='logbox'>
            <div style="background: #fff;border-radius: 5px; overflow: hidden; " class=" ">
              <div class="d-flex align-items-center p-2" style="border-bottom:1px solid #f5f5f5">
          <div :style="{background:userinfo.color}"  class="d-flex align-items-center justify-content-center log">
           <span style="font-size:14px;font-weight:500;color:#fff;text-transform: uppercase!important;user-select: none!important;">{{userinfo.name[0]}}</span>
         </div>
         <div style="padding-left:15px">
           
           <p style="margin-bottom:2px;color: rgb(32, 34, 43);font-weight:400;font-size:14px">{{userinfo.name}}</p>
            <p  style="margin-bottom:0px;color: rgb(125, 130, 156);font-weight:400;font-size:13px">{{userinfo.email}}</p>
         </div>
              </div>
              <div class="d-flex align-items-center justify-content-center">
                <i class='bx bx-log-out-circle' style="color:#000;font-size:22px" ></i>
             <div style="font-size:15px;color: #000;font-size: 14px;font-weight: 500;padding: 10px;text-transform: unset!important;white-space: nowrap!important;user-select: none!important;" v-on:click='loutbox=true'>Log out</div>
              </div>
              
           </div>
           </div>
         </div>
          </div>


               <div style="" class="mobcons">
                <div>
    <img src="../assets/empty.svg" style="width:100px;transform: translateX(-10px);">
    <h2 style="font-size:18px;font-weight: 500;color: #fff;" class="mt-4" >No Projects  Found</h2>
    <div class="mt-3">
    <button v-on:click='addboxproject=true' style="background:#01C390;border:none;outline:none;padding:6px 25px;border-radius:5px">Add Project</button>
  </div>
  </div>
</div>
            </div>
         </div>
       <div class="cuswidth"   v-on:drop="dropHere($event)" v-on:dragover="allowDrop($event)"   v-else-if='leftsides.length>0 && !load' style='padding:0px'>
       
         <div style='  height:100vh;background:#15151C;padding:0px' class="d-flex flex-column">



          <div class="d-flex align-items-center justify-content-between top1box" style="">
 
             <div style="position:relative; " class="d-flex align-items-center fl1">
              <i class='bx bx-menu d-md-none d-block'  v-on:click='lboxstatus=!lboxstatus' style="font-size:30px;color:rgb(184, 193, 207);margin-right: 10px;" ></i>
                 <div class=" fl1 " style="">
              <div style="position: relative; ">
                <input type="text" v-model='searchtext'  style="cursor: pointer;width:250px;height:35px;border:none;outline:none;box-shadow: none;background: transparent;color: #666;font-size: 13px;background:rgb(32, 34, 43);border-radius: 7px;padding: 7px 14px;cursor: pointer;border: 1px solid rgb(32, 34, 43);    color:#000;transition: all 0.5s;" class="sform" placeholder="Jump to project or file..." name="">

             </div>
           </div>

<div style="position:fixed;top:0;left: 0;right: 0;bottom: 0;" v-if='getsearch.length>0 || getfolder.length>0'  v-on:click="searchtext=''"></div>
<div v-if='getsearch.length>0 || getfolder.length>0 ' style="width:300px;padding:10px;border-radius: 5px;position: absolute;top: 40px;left: 0;background: #fff;box-shadow: 0 0 10px rgba(0,0,0,0.1);z-index: 100000000;max-height: 500px;overflow: scroll;">






<p style="font-size:13px;color: #b8c1cf;font-weight: 400;margin-top: 20px;margin-left: 5px;" v-if='getfolder.length>0'>
  Projects
</p>
  <template v-for='(itm,index) in getfolder' v-if='getfolder.length>0'>
    <div  class='srcbox'  v-on:click="getdatas(itm)" :style="{'borderBottom':(index==getfolder.length-1)?'none':'1px solid #f5f5f5'}">
     <div>
       <p style="font-size:13px;font-weight: 400; transition: all 0.3s;" > {{itm.name}}</p>
       
     </div>
    </div>
  </template>

<p v-if='getsearch.length>0' style="font-size:13px;color: #b8c1cf;font-weight: 400;margin-top: 20px;margin-left: 5px;">
  Videos
</p>
  <template v-if='getsearch.length>0' v-for='(itm,index) in getsearch'>
    <router-link :to="'/videoview?id='+itm.ids+'&folder='+cdocid"  class='srcbox' :style="{'borderBottom':(index==getsearch.length-1)?'none':'1px solid #f5f5f5'}">
     <div>
       <p style="font-size:13px;font-weight: 400; transition: all 0.3s;" > {{itm.name}}</p>
       <div class="d-flex align-items-center">
         
                        <span style="max-width: 80px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;;color:rgb(125, 130, 156);font-size:13px;font-weight: 300;">{{itm.uploader.name}} </span> 
                        <span style="display:inline-block;width: 2px;height: 2px;background: #6F748C;border-radius: 50%;margin:0px 3px"></span>
                        <span style="margin-left: 0px;color:rgb(125, 130, 156);font-size:13px;font-weight: 300;white-space: nowrap;" class="cusdate">{{renderdates(itm)}} , {{itm.time}} </span>


       </div>
     </div>
    </router-link>
  </template>


</div>

</div>

 

<div style="position:fixed;top:0;left: 0;right: 0;bottom: 0;z-index: 10000;cursor: pointer; " v-if='logbox'  v-on:click="logbox=false"></div>

         <div v-if='userdataloaded' :style="{background:userinfo.color}" v-on:click="logbox=!logbox" class="d-flex align-items-center justify-content-center log">
           <span style="font-size:14px;font-weight:500;color:#fff;text-transform: uppercase!important;user-select: none!important;">{{userinfo.name[0]}}</span>
           <div style="" class="logsub" v-if='logbox'>
            <div style="background: #fff;border-radius: 5px; overflow: hidden; " class=" ">
              <div class="d-flex align-items-center p-2" style="border-bottom:1px solid #f5f5f5">
          <div :style="{background:userinfo.color}"  class="d-flex align-items-center justify-content-center log">
           <span style="font-size:14px;font-weight:500;color:#fff;text-transform: uppercase!important;user-select: none!important;">{{userinfo.name[0]}}</span>
         </div>
         <div style="padding-left:15px">
           
           <p style="margin-bottom:2px;color: rgb(32, 34, 43);font-weight:400;font-size:14px">{{userinfo.name}}</p>
            <p  style="margin-bottom:0px;color: rgb(125, 130, 156);font-weight:400;font-size:13px">{{userinfo.email}}</p>
         </div>
              </div>
              <div class="d-flex align-items-center justify-content-center">
                <i class='bx bx-log-out-circle' style="color:#000;font-size:22px" ></i>
             <div style="font-size:15px;color: #000;font-size: 14px;font-weight: 500;padding: 10px;text-transform: unset!important;white-space: nowrap!important;user-select: none!important;" v-on:click='loutbox=true'>Log out</div>
              </div>
              
           </div>
           </div>
         </div>
          </div>


           <div style=" " class="d-flex align-items-center top2box " >
             <div class="d-flex align-items-center" style="min-width: 0px;">
               <div style="width:35px;border-radius: 5px;overflow:hidden;min-width:35px" class="subimg">
                 <img src="https://firebasestorage.googleapis.com/v0/b/staging-wlshop.appspot.com/o/websitelearners_logo_790924.png?alt=media&token=aaa8373b-30af-431a-9ae4-8550d79fb07b" style="width:100%">
               </div>


<div style="position:relative;min-width: 0px;">
               <div style="" class="toptext">
               <h2 id="mais" class="maintext" style="width: fit-content;font-size: 17px;font-weight:400;color: #EFF1F5;margin-bottom: 0px;margin-left: 20px; text-overflow: ellipsis;white-space: nowrap;cursor: pointer;" v-if='Object.entries(currentdata).length>0'>{{currentdata.name}}</h2>




               <div v-if='hides' class="submaintext " style="  position: absolute;bottom: 30px;left: 20px; right:0;display: none;padding-top: 20px;cursor: pointer;z-index: 1000000000000; ">

                <h2 class="" style="position: relative;font-size: 12px;font-weight:400;color: #EFF1F5;margin-bottom: 0px;margin-left: 0px;width: 100%;padding: 6px;background:#323744;border-radius: 5px;opacity: 1;line-height: 19px" v-if='Object.entries(currentdata).length>0'>{{currentdata.name}}
                <div style="width:20px;height:20px;border: 10px solid transparent;
    border-bottom-color: #323744;position: absolute; left: 50%; ;    bottom: -20px;
    left: 50%;
    transform: translateX(-50%) rotate(180deg);"></div>
  </h2>
              </div>
             </div>
             
{{setor}}
</div>

             </div>
             <span v-if='hides'  style="font-size: 18px;font-weight:500;color: #EFF1F5;margin-right: 40px;" >...</span>

 


              <div class="d-md-none d-flex align-items-center" style="margin-left:auto">
                <div v-on:click='copylinks' style="width:30px;height:30px;border-radius:50%;background:#323744;margin-right:20px;cursor: pointer;" class="d-flex align-items-center justify-content-center">
                  <i class='bx bxs-user-plus' style="font-size:18px;color: #fff;" ></i>
                </div>


 


             <label    class="d-flex align-items-center  "  style="padding: 0px;margin-bottom: 0px;position: relative;">
              <input v-on:change='readfile($event,1)' accept="video/*,image/*,audio/*"  v-on:click='nullfile($event)'   multiple type="file" style="position:absolute;opacity: 0;z-index: -1;top: 0;" name="">
               <i class='bx bxs-video-plus' style="color:#fff;font-size: 20px;" ></i>
              
             </label>
             <!--
             <div  v-if='fileuplaod' class="d-flex align-items-center"  style=" margin-left:10px;position: relative;margin-bottom: 0px;cursor: pointer;opacity: 0.7;">
               <i class='bx bxs-video-plus' style="color:#fff;font-size: 20px;" ></i>
              </div>
            -->



           </div>







                  


<div class="d-md-flex d-none align-items-center" style="margin-left:auto;user-select: none;">
 <div style="position:fixed;top:0;left: 0;right: 0;bottom: 0;cursor: pointer;z-index: 10000000;" v-on:click='sortbox=false' v-if='sortbox'></div>
      <div v-on:click='sortbox=!sortbox' class="d-flex align-items-center  " style="margin:0px 10px;position: relative;">
        <p style="margin-bottom: 0px;color: #b8c1cf;font-size: 15px;font-weight: 400;cursor: pointer;white-space: nowrap;">{{sorttext}}</p>
                       <i class='bx bx-chevron-down' style="font-size:20px;color:#b8c1cf;margin-left: 0px;cursor: pointer"  ></i>
                       <div  v-if='sortbox' style="position:absolute;top: 30px;width: 150px;padding: 14px;background: #fff;border-radius: 5px;box-shadow: 0 0 10px rgba(0,0,0,0.1);right: -10px;cursor: pointer;z-index: 100000000000;">
                       <p style="color:rgb(125, 130, 156);font-size: 12px;font-weight: 400;padding: 5px;">Sort by</p>
                       <div>
                         <p   :class="{'sorttext':true,'actsort':sorttext=='Date uploaded'}" v-on:click="sorttext='Date uploaded'">Date uploaded</p>
                         <p :class="{'sorttext':true,'actsort':sorttext=='Name'}" v-on:click="sorttext='Name'">Name</p>
                         <p :class="{'sorttext':true,'actsort':sorttext=='Size'}" v-on:click="sorttext='Size'">Size</p>
                         <p :class="{'sorttext':true,'actsort':sorttext=='Comments'}" v-on:click="sorttext='Comments'">Comments</p>
                       </div>
                       </div>

      </div>

                <div v-on:click='copylinks' style="min-width:30px;width: 30px;height:30px;border-radius:50%;background:#323744;margin-right:20px;cursor: pointer!important;" class="d-none align-items-center justify-content-center">
                  <i class='bx bxs-user-plus' style="font-size:18px;color: #fff;" ></i>
                </div>


<div v-on:click='invbox=true' style="width:30px;height:30px;border-radius:50%;background:#323744;margin-right:20px;cursor: pointer!important;" class="d-flex align-items-center justify-content-center">
                  <i class='bx bxs-user-plus' style="font-size:18px;color: #fff;" ></i>
                </div>
             <div class="d-flex align-items-center">


               
              <template v-for='itm in getallusers'>
               <div :style="{background:itm.color,position:'relative',cursor:'pointer'}" :key='itm.mobile' class="usericon"  >
                  <div class="usericonsub" style="position:absolute;background: #20222B;padding: 10px;border-radius: 5px;top:28px;left:50%;transform: translateX(-50%);color: #fff;font-weight: 400;font-size: 12px;display: none;">{{itm.email}}</div>
                <span style="font-size:14px;font-weight: 400;color: #fff;text-transform: uppercase;">{{itm.name[0]}}</span></div>
               </template>
 

             
                
               <div style="width:25px;height:25px;border-radius:50%;background: #7D829C;position: relative;z-index: 1;" class="d-none align-items-center justify-content-center">
                <span style="font-size:8px;font-weight: 400;color: #fff"><i class='bx bx-plus' style="font-size:8px;color: #fff;
    vertical-align: middle;" ></i>43</span>
  </div>
             </div>

    

             <label v-if='!tempdocid.includes(cdocid)'    class="d-flex align-items-center uplbtn"  style="">
              <input v-on:change='readfile($event,1)' accept="video/*,image/*,audio/*"  v-on:click='nullfile($event)'   multiple type="file" style="position:absolute;opacity: 0;z-index: -1;top: 0;" name="">
               <i class='bx bxs-video-plus' style="color:#fff;font-size: 18px;" ></i>
               <p style="color:#fff;font-size: 15px;margin-left:6px;font-weight: 500;">New</p>
             </label>
  <div   v-else   class="  uplbtn"  style="position: relative;overflow: hidden;width: 80px;text-align: center;">
             
                <p style="color:#fff;font-size: 15px;margin-left:0px;font-weight: 500;position: relative;z-index: 1000;text-align: center;">{{tasks[tempdocids].percentage}}</p>

               <div class="water-effect" :style="{'bottom':-(100-Number(tasks[tempdocids].percentage.slice(0,tasks[tempdocids].percentage.length-1)))+'%!important'}">
    <div class="waves"></div>
    <div class="water"></div>
  </div>

             </div>

           



           </div>












           </div>
           
           <div style="" class="mainbox">
              <div class="container-fluid">
                <div v-if='allvideos.length==0 && !fileuplaod && !localloader'>
 
 

  <div style=" "   class="mobconss">
    <img src="../assets/empty.svg" style="width:100px;transform: translateX(-10px);">
    <h2 style="font-size:18px;font-weight: 500;color: #fff;" class="mt-4" >No videos Found</h2>
  </div>
     
</div>
 
  



                <div class="row">




              <div class="cusclas mb-4" v-if='  tempdocid.includes(cdocid)'  style="position:relative;">
                     
                   

  <div style="border-radius:5px;overflow:hidden;cursor: pointer;position: relative;height: 100%;background: #303247;">

  <div style="border-radius:5px;overflow:hidden;cursor: pointer; height: 100%;padding: 50px 0px;background:#303247;animation: open 0.5s;position: absolute;top: 0;left: 0;right: 0;bottom: 0;z-index: 1000;" class="d-flex align-items-center">
                     
                    <div style="padding:0px 10px;width: 100%;" >

                      <h2 style="font-size:16px;color:#EFF1F5;overflow:hidden;text-overflow: ellipsis;font-weight: 400;white-space: nowrap;text-align: center;"> Uploading... {{tasks[tempdocids].percentage}}</h2>
                      <div style="width:80%;height:10px;border-radius:30px;background:#444652;overflow: hidden;margin:3px auto">
                        <div :style="{width:tasks[tempdocids].percentage,background: '#7D829C',height: '100%'}"></div>
                      </div>

                      <div class="d-flex align-items-center justify-content-center mt-3">
                        
                        <i class='bx bx-pause-circle' style="font-size:30px;color:#7D829C;cursor: pointer;" v-if='tasks[tempdocids].status==undefined || !tasks[tempdocids].status'  v-on:click='pauseupload'  ></i>

                        <i class='bx bx-play-circle' style="font-size:30px;color:#7D829C;cursor: pointer;" v-else  v-on:click='pauseupload'></i>
                      </div>
                       
                     
                    </div>
                  </div>

                    <div style="position:relative;overflow: hidden;border-radius: 10px;">
                   

                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5QEJ1jr1Hlnzj_fyf6BlreyyoaN7zcpaiwA&usqp=CAU" style="width:100%">
                    </div>

                   
                    <div style="background:#303247;padding:15px 10px">

                      <div style="position:relative;">
                      <h2 class="ads" style="font-size:14px;color:#EFF1F5;overflow:hidden;text-overflow: ellipsis;font-weight: 400;white-space: nowrap;">sdfsdf</h2>

                      <h2 class="adssub" style="font-size:12px;color:#f1f3f6;  font-weight: 300; ;position: absolute;padding:   10px;background: #2B2E3B; white-space: nowrap;border-radius: 5px;top:-45px;left: 50%;z-index: 1000;
    transform: translateX(-50%) ">aafsesd <div style="width:20px;height:20px;border: 10px solid transparent;
    border-bottom-color: #2B2E3B;position: absolute;bottom: 0;left: 50%; ;    bottom: -20px;
    left: 50%;
    transform: translateX(-50%) rotate(181deg);"></div></h2>
                    </div>
                      <div style="color:#6F748C;font-size:13px;font-weight: 400;" class="d-flex align-items-center "><span>sdfdsfdsfds</span> <span style="display:inline-block;width: 4px;height: 4px;background: #6F748C;border-radius: 50%;margin:0px 3px"></span> <span style="margin-left: 0px">dsfds</span>
                       <div class="d-flex align-items-center justify-content-end"   style="margin-left:auto;">
                        <i class='bx bxs-message-rounded' style="color:#6F748C;font-size:17px;font-weight: 400;margin-right: 5px;"  ></i>
                        <p style="color:#6F748C;font-size:13px;font-weight: 400;margin-bottom: 0px;" class="d-flex align-items-center ">edwfe</p>

                      </div>

                    </div>
                     
                    </div>
                  </div>
                
                





                  </div>


 
                  <template v-for='itm of getallvid' v-if='allvideos.length>0'>
                  <div class="  mb-md-4 mb-0 cusclas" v-if="itm.type=='video'">

                    <router-link :to="'/videoview?id='+itm.ids+'&folder='+cdocid" style='text-decoration: none;height: 100%;'>
                    <div style="border-radius:5px;overflow:visible;cursor: pointer;position: relative;height: 100%;background: rgb(48, 50, 71);">




                     





                    <div style="position:relative;border-radius:5px;overflow: hidden;border-bottom-left-radius: 0px;border-bottom-left-radius: 0px;padding-bottom: 60%;">
                        <div class="d-flex align-items-center"   style="position:absolute;bottom: 4px;right: 8px;background: rgba(15, 16, 20, 0.8);padding: 2px 6px;border-radius: 5px;z-index: 10 ">
               
                <p style="margin-bottom:0px;font-weight:400;color:#fff;font-size:12px;margin-left:8px;">{{rendermins(itm.duration)}}</p>
              </div>
 
              <div class="d-flex align-items-center" v-if="itm.status==1" style="position:absolute;top: 4px;right: 8px;background: rgba(15, 16, 20, 0.8);padding: 4px 8px;border-radius: 5px;overflow: hidden;z-index: 100;">
                <div style="width:10px;height:10px;border-radius:50%;border:1px solid #ff9659;background:#ff9659"></div>
                <p style="margin-bottom:0px;font-weight:400;color:#fff;font-size:12px;margin-left:8px">Needs Review  </p>
              </div>
              <div class="d-flex align-items-center" v-if="itm.status==2"  style="position:absolute;top: 4px;right: 8px;background: rgba(15, 16, 20, 0.8);padding: 4px 8px;border-radius: 5px;overflow: hidden;z-index: 100;" >
                <div style="width:10px;height:10px;border-radius:50%;border:1px solid #61caff;background:#61caff"></div>
                <p style="margin-bottom:0px;font-weight:400;color:#fff;font-size:12px;margin-left:8px">In Progress</p>
              </div>


              <div class="d-flex align-items-center" v-if="itm.status==3" style="position:absolute;top: 4px;right: 8px;background: rgba(15, 16, 20, 0.8);padding: 4px 8px;border-radius: 5px;overflow: hidden;z-index: 100;"  >
                <div style="width:10px;height:10px;border-radius:50%;border:1px solid #1dc0a6;background:#1dc0a6"></div>
                <p style="margin-bottom:0px;font-weight:400;color:#fff;font-size:12px;margin-left:8px">Approved</p>
              </div>


                      <img :src="itm.thumb" style="width:100%;height:100%;object-fit: cover;position: absolute;top: 0;left: 0;">
                    </div>
                    <div style="background:#303247;padding:15px 10px;border-radius: 5px;">

                      <div style="position:relative;">
                      <h2 class="ads" style="font-size:13px;color:rgb(241, 243, 246);overflow:hidden;text-overflow: ellipsis;font-weight: 400;white-space: nowrap;margin-bottom: 5px">{{itm.name}}</h2>

                      <h2 class="adssub" style="font-size:12px;color:#f1f3f6;  font-weight: 300; ;position: absolute;padding:   10px;background: #2B2E3B; white-space: nowrap;border-radius: 5px;top:-45px; z-index: 1000;
     ">{{itm.name}}  <div style="width:20px;height:20px;border: 10px solid transparent;
    border-bottom-color: #2B2E3B;position: absolute;bottom: 0;left: 50%; ;    bottom: -20px;
    left: 20px;
    transform:rotate(181deg);"></div></h2>
                    </div>
                      <div style="color:rgb(125, 130, 156);font-size:13px;font-weight: 300;flex-wrap: nowrap;" class="d-flex align-items-center   ">

                        <span style="max-width: 80px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;;color:rgb(125, 130, 156);font-size:13px;font-weight: 300;">{{itm.uploader.name}}</span> 
                        <span style="display:inline-block;width: 2px;height: 2px;background: #6F748C;border-radius: 50%;margin:0px 3px"></span>
                        <span style="margin-left: 0px;color:rgb(125, 130, 156);font-size:13px;font-weight: 300;white-space: nowrap;" class="cusdate">{{renderdates(itm)}} , {{itm.time}} </span>


                       <div class="d-flex align-items-center justify-content-end" v-if='itm.commentcount!=0' style="margin-left:auto;padding-left: 10px;">
                        <i class='bx bxs-message-rounded' style="color:#6F748C;font-size:16px;font-weight: 400;margin-right: 5px;"  ></i>
                        <p style="color:rgb(125, 130, 156);font-size:12px;font-weight: 400;margin-bottom: 0px;" class="d-flex align-items-center ">{{itm.commentcount}}</p>

                      </div>

                    </div>
                     
                    </div>
                  </div>
                </router-link>

                  </div>










                   <div class="  mb-md-4 mb-0 cusclas" v-if="itm.type=='audio'">

                    <router-link :to="'/audioview?id='+itm.ids+'&folder='+cdocid" style='text-decoration: none;height: 100%;'>
                    <div style="border-radius:5px;overflow:visible;cursor: pointer;position: relative;height: 100%;background: rgb(48, 50, 71);">




                     





                    <div style="position:relative;border-radius:5px;overflow: hidden;border-bottom-left-radius: 0px;border-bottom-left-radius: 0px;padding-bottom: 60%;">
                        <div class="d-flex align-items-center"   style="position:absolute;bottom: 4px;right: 8px;background: rgba(15, 16, 20, 0.8);padding: 2px 6px;border-radius: 5px;z-index: 100; ">
               
                <p style="margin-bottom:0px;font-weight:400;color:#fff;font-size:12px;margin-left:8px">{{rendermins(itm.duration)}}</p>
              </div>
 
              <div class="d-flex align-items-center" v-if="itm.status==1" style="position:absolute;top: 4px;right: 8px;background: rgba(15, 16, 20, 0.8);padding: 4px 8px;border-radius: 5px;overflow: hidden;z-index: 100;">
                <div style="width:10px;height:10px;border-radius:50%;border:1px solid #ff9659;background:#ff9659"></div>
                <p style="margin-bottom:0px;font-weight:400;color:#fff;font-size:12px;margin-left:8px">Needs Review  </p>
              </div>
              <div class="d-flex align-items-center" v-if="itm.status==2"  style="position:absolute;top: 4px;right: 8px;background: rgba(15, 16, 20, 0.8);padding: 4px 8px;border-radius: 5px;overflow: hidden;z-index: 100;" >
                <div style="width:10px;height:10px;border-radius:50%;border:1px solid #61caff;background:#61caff"></div>
                <p style="margin-bottom:0px;font-weight:400;color:#fff;font-size:12px;margin-left:8px">In Progress</p>
              </div>


              <div class="d-flex align-items-center" v-if="itm.status==3" style="position:absolute;top: 4px;right: 8px;background: rgba(15, 16, 20, 0.8);padding: 4px 8px;border-radius: 5px;overflow: hidden;z-index: 100;"  >
                <div style="width:10px;height:10px;border-radius:50%;border:1px solid #1dc0a6;background:#1dc0a6"></div>
                <p style="margin-bottom:0px;font-weight:400;color:#fff;font-size:12px;margin-left:8px">Approved</p>
              </div>


                      <img :src="itm.thumb" style="width:100%;height:100%;object-fit: cover;position: absolute;top: 0;left: 0;">
                    </div>
                    <div style="background:#303247;padding:15px 10px;border-radius: 5px;">

                      <div style="position:relative;">
                      <h2 class="ads" style="font-size:13px;color:rgb(241, 243, 246);overflow:hidden;text-overflow: ellipsis;font-weight: 400;white-space: nowrap;margin-bottom: 5px">{{itm.name}}</h2>

                      <h2 class="adssub" style="font-size:12px;color:#f1f3f6;  font-weight: 300; ;position: absolute;padding:   10px;background: #2B2E3B; white-space: nowrap;border-radius: 5px;top:-45px; z-index: 1000;
     ">{{itm.name}}  <div style="width:20px;height:20px;border: 10px solid transparent;
    border-bottom-color: #2B2E3B;position: absolute;bottom: 0;left: 50%; ;    bottom: -20px;
    left: 20px;
    transform:rotate(181deg);"></div></h2>
                    </div>
                      <div style="color:rgb(125, 130, 156);font-size:13px;font-weight: 300;flex-wrap: nowrap;" class="d-flex align-items-center   ">

                        <span style="max-width: 80px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;;color:rgb(125, 130, 156);font-size:13px;font-weight: 300;">{{itm.uploader.name}}</span> 
                        <span style="display:inline-block;width: 2px;height: 2px;background: #6F748C;border-radius: 50%;margin:0px 3px"></span>
                        <span style="margin-left: 0px;color:rgb(125, 130, 156);font-size:13px;font-weight: 300;white-space: nowrap;" class="cusdate">{{renderdates(itm)}} , {{itm.time}} </span>


                       <div class="d-flex align-items-center justify-content-end" v-if='itm.commentcount!=0' style="margin-left:auto;padding-left: 10px;">
                        <i class='bx bxs-message-rounded' style="color:#6F748C;font-size:16px;font-weight: 400;margin-right: 5px;"  ></i>
                        <p style="color:rgb(125, 130, 156);font-size:12px;font-weight: 400;margin-bottom: 0px;" class="d-flex align-items-center ">{{itm.commentcount}}</p>

                      </div>

                    </div>
                     
                    </div>
                  </div>
                </router-link>

                  </div>






 <div class="  mb-md-4 mb-0 cusclas" v-if="itm.type=='image'">

                    <router-link :to="'/imageview?id='+itm.ids+'&folder='+cdocid" style='text-decoration: none;height: 100%;'>
                    <div style="border-radius:5px;overflow:visible;cursor: pointer;position: relative;height: 100%;background: rgb(48, 50, 71);">




                     





                    <div style="position:relative;border-radius:5px;overflow: hidden;border-bottom-left-radius: 0px;border-bottom-left-radius: 0px;padding-bottom: 60%;">
                      
 
              <div class="d-flex align-items-center" v-if="itm.status==1" style="position:absolute;top: 4px;right: 8px;background: rgba(15, 16, 20, 0.8);padding: 4px 8px;border-radius: 5px;overflow: hidden;z-index: 100;">
                <div style="width:10px;height:10px;border-radius:50%;border:1px solid #ff9659;background:#ff9659"></div>
                <p style="margin-bottom:0px;font-weight:400;color:#fff;font-size:12px;margin-left:8px">Needs Review  </p>
              </div>
              <div class="d-flex align-items-center" v-if="itm.status==2"  style="position:absolute;top: 4px;right: 8px;background: rgba(15, 16, 20, 0.8);padding: 4px 8px;border-radius: 5px;overflow: hidden;z-index: 100;" >
                <div style="width:10px;height:10px;border-radius:50%;border:1px solid #61caff;background:#61caff"></div>
                <p style="margin-bottom:0px;font-weight:400;color:#fff;font-size:12px;margin-left:8px">In Progress</p>
              </div>


              <div class="d-flex align-items-center" v-if="itm.status==3" style="position:absolute;top: 4px;right: 8px;background: rgba(15, 16, 20, 0.8);padding: 4px 8px;border-radius: 5px;overflow: hidden;z-index: 100;"  >
                <div style="width:10px;height:10px;border-radius:50%;border:1px solid #1dc0a6;background:#1dc0a6"></div>
                <p style="margin-bottom:0px;font-weight:400;color:#fff;font-size:12px;margin-left:8px">Approved</p>
              </div>


                      <img :src="itm.thumb" style="width:100%;height:100%;object-fit: cover;position: absolute;top: 0;left: 0;">
                    </div>
                    <div style="background:#303247;padding:15px 10px;border-radius: 5px;">

                      <div style="position:relative;">
                      <h2 class="ads" style="font-size:13px;color:rgb(241, 243, 246);overflow:hidden;text-overflow: ellipsis;font-weight: 400;white-space: nowrap;margin-bottom: 5px">{{itm.name}}</h2>

                      <h2 class="adssub" style="font-size:12px;color:#f1f3f6;  font-weight: 300; ;position: absolute;padding:   10px;background: #2B2E3B; white-space: nowrap;border-radius: 5px;top:-45px; z-index: 1000;
     ">{{itm.name}}  <div style="width:20px;height:20px;border: 10px solid transparent;
    border-bottom-color: #2B2E3B;position: absolute;bottom: 0;left: 50%; ;    bottom: -20px;
    left: 20px;
    transform:rotate(181deg);"></div></h2>
                    </div>

                      <div style="color:rgb(125, 130, 156);font-size:13px;font-weight: 300;flex-wrap: nowrap;" class="d-flex align-items-center   ">

                        <span style="max-width: 80px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;;color:rgb(125, 130, 156);font-size:13px;font-weight: 300;">{{itm.uploader.name}}</span> 
                        <span style="display:inline-block;width: 2px;height: 2px;background: #6F748C;border-radius: 50%;margin:0px 3px"></span>
                        <span style="margin-left: 0px;color:rgb(125, 130, 156);font-size:13px;font-weight: 300;white-space: nowrap;" class="cusdate">{{renderdates(itm)}} , {{itm.time}} </span>


                       <div class="d-flex align-items-center justify-content-end" v-if='itm.commentcount!=0' style="margin-left:auto;padding-left: 10px;">
                        <i class='bx bxs-message-rounded' style="color:#6F748C;font-size:16px;font-weight: 400;margin-right: 5px;"  ></i>
                        <p style="color:rgb(125, 130, 156);font-size:12px;font-weight: 400;margin-bottom: 0px;" class="d-flex align-items-center ">{{itm.commentcount}}</p>

                      </div>

                    </div>
                     
                    </div>
                  </div>
                </router-link>

                  </div>









                  </template>



                </div>
                  <div class="mobconss"  v-if='localloader'>
 
 

 
 <div style="text-align:center;"    >
          <img src="../assets/loader.gif" style="width:100px;">
        </div>
       
</div>
              </div>
           </div>
          
         </div>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
  const fb = require('../firebase/firebaseconfig.js')
 import axios from 'axios'
 
 
export default {
 
   

      props:['wlgigs','loaded','signedin','countrycode','fav','favall','wlgigobj','userinfo','userdataloaded','allteam'],
  data () {

        return{
   signedinby:'google',acceptlink:false,
testbool:false,
dontext:false,
   mas:'re',
   tasks:{},
   sorttext:'Date uploaded',
   rmbox:false,
   testdata:{
      '1':{selected:false,
    name:'ssdsdsdsd'},
    '2':{selected:false,
    name:'ssdsdsdsd'}

   },
   invtext:'',
   hides:false,
   sortbox:false,
   loutbox:false,
   logbox:false,
   localloader:false,
   foldervisible:true,
   allvideos:[],
   task:{},
   tempdocid:[],
   tempdocids:'',
   objs:{},
   donacttext:'Vectors',
tabsss:1,
invbox:false,
lboxstatus:false,

searchtext:'',
currentdata:{},
copylink:false,
email:'',
teststatus:true,
levbox:false,
loadstarted:false,
projectname:'',
addboxproject:false,
projectnames:'',
editprobox:false,
   name:'',
   fileuplaod:false,
   chid:'',
   percentage:'0%',
   editbox:false,
   proname:'',
   formsubmited:false,
   addboxs:false,
   cid:'',
   tab:0,
   editdata:{},
   question:[{
    id:0,
    title:'Enter your Name',
    answer:'',
    type:'input',
    error:false,
   },
   {
    id:1,
    title:'What would you like to do?',
    answer:'',
    type:'option',
    options:['Extend Video','Hold Video','Resume Video','Set Deadline After Feedback'],
      error:false,
   }],
   deldata:{},
   delbox:false,
   bid:'',
   addbox:false,
   editboxsss:false,
   profiletext:'',
   leads:[],
   tempmanager:null,
   cusitems:{  x:150,
  y:150,
  width:300,
  height:300,
  angle:0,}, 
   items:{
  x:150,
  y:150,
  width:300,
  height:300,
  angle:0,

},

   drawer:false,
   name:'',
   searchtxt:'',
 key:'all',
 names:'a',
 tabid:0,
 cdocid:'',
 load:true,
 leftsides:[]

 
        }
     
    
  },
    async created(){
 

 /*
const options = {
  url: 'https://firebasestorage.googleapis.com/v0/b/staging-wlshop.appspot.com/o/bbb-thumbnails.vtt?alt=media&token=cced4378-86a3-49e2-a671-f73fcf90b057',
  method: 'GET',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json;charset=UTF-8'
  },
  
};

axios(options)
  .then(response => {
 //console.log('=--==')
  
 
  var x=response.data



 
 const blob = new Blob([x.replace(/..\//g, "red")], {
  type: 'text/vtt' // or whatever your Content-Type is
});

 
 
var storageref=fb.storage.ref('vtt/file.vtt');
        var task = storageref.put(file);

        //Update progress bar
        task.on('state_changed',
            function progress(snapshot){
                


                     var pt=(snapshot.bytesTransferred/snapshot.totalBytes)*100;

                     //console.log(pt+'---'+docid)
//console.log(vm.tempdocids==docid)
                  if(vm.tempdocids==docid){

//console.log('docid='+docid)
                     vm.currentdata.percentage=Math.round(pt)+'%'

                   }
 

      
            },
            function error(err){
             
                //console.log(err);
                reject(err);
            },
            async function complete (){
              //console.log(task.snapshot)
               
                var downloadURL =await task.snapshot.ref.getDownloadURL()
              
                resolve({downloadURL,docid});
            }
        );

});

*/





  var vm=this
if(fb.auth.currentUser!=null){
 this.email=fb.auth.currentUser.email
 
 
 if(this.$route.query.invite!=undefined){ 
      var x=await this.getinvite()
    
 } 
 
 
 

 var docRef = fb.db.collection("wlframeprojects").where('users','array-contains',fb.auth.currentUser.email).orderBy('createdon','desc')
 .onSnapshot((querySnapshot) => {
         var i=0
         var leftsides=[]

var locdoc=window.localStorage.getItem('cdoc')
 

       querySnapshot.forEach((doc) => {








  if(locdoc!=null){


              

if (doc.id == locdoc) {
 vm.currentdata = {
            ...doc.data(),
              id: i,
              ids:doc.id,
               percentage:'-90%'
         }
         leftsides.push({
            ...doc.data(),
            id: i,
            selected: true,
            ids: doc.id,
            selectedright: false,
             percentage:'-90%'
         })
          this.cdocid = doc.id

   }else{

leftsides.push({
            ...doc.data(),
            id: i,
            selected: false,
            ids: doc.id,
            selectedright: false,
             percentage:0
         })
   }
              
      
      }else{

   if (i == 0) {
 vm.currentdata = {
            ...doc.data(),
              id: i,
              ids:doc.id,
                 percentage:'-90%'
         }
         leftsides.push({
            ...doc.data(),
            id: i,
            selected: true,
            ids: doc.id,
            selectedright: false,
               percentage:'-90%'
         })
          this.cdocid = doc.id

   }else{

leftsides.push({
            ...doc.data(),
            id: i,
            selected: false,
            ids: doc.id,
             percentage:0,
            selectedright: false
         })
   }




          }



 i = i + 1

 
});





 vm.leftsides=[
        ...leftsides

        ]

 

//console.log(this.cdocid)
if(this.cdocid==''){

        vm.load=false
}
var allvideos=[]
var docRef = fb.db.collection("wlframeprojects").doc(this.cdocid).collection('videos').orderBy("cdate",'desc').get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          
            //console.log(doc.id, " => ", doc.data());

            allvideos.push({...doc.data(),ids:doc.id})
        });

        vm.allvideos=[
        ...allvideos
        ]
        //console.log('vm.allvideos')

        //console.log(vm.allvideos)

        vm.load=false

    })
    .catch((error) => {

        //console.log("Error getting documents: ", error);
    });



    

     });



 





}else{

  if(this.$route.query.invite!=undefined){
this.$router.replace({path:'/login?invite='+this.$route.query.invite})
  }else{
    this.$router.replace({path:'/login'})
  }
  
}
  },
  mounted(){ 


 


} 
   ,
  computed:
  {
  
       getstatus(){

        //console.log('-----'+this.tempdocids)
        //console.log(this.tasks)
      return this.tasks[this.tempdocids].status
    },
    //"31:5:2022"
    getallvid(){


 
      if(this.sorttext=='Date uploaded'){

        var x="31:5:2022"

        var x="5/31/2022"
 

 
return this.allvideos.sort(function(a,b){
   return Number(b.counts)-Number(a.counts );

});

      }
      else if(this.sorttext=='Name'){
       
       return this.allvideos.sort(function(a,b){
 
  return a.name.localeCompare(b.name);

});
      }
       else if(this.sorttext=='Size'){
       


var exlimages=this.allvideos.filter((itm)=>{
return itm.type!='image'

})
var onlyimage=this.allvideos.filter((itm)=>{
return itm.type=='image'

})


  var sizecom= exlimages.sort(function(a,b){
 
  return Number(b.duration)-Number(a.duration );

});

  var final=[
  ...sizecom,
  ...onlyimage
  ]
return final
      }
       else if(this.sorttext=='Comments'){
       
       return this.allvideos.sort(function(a,b){
 
  return  b.commentcount- a.commentcount

});
      }
        


      
    },


alleteam(){
  if(this.invtext!=''){
if(this.allteam.length==0){
  return []
}else{
  var x=this.allteam.filter((itm)=>{

    return itm.memberinfo.name.toLowerCase().match(this.invtext.toLowerCase())
  })
  return x
}
}else{
  return []
}
},
    setor(){


//console.log(this.currentdata)
 var vm=this

setTimeout(()=>{
 if(document.getElementById('mais').offsetWidth>300){
  vm.hides=true
}else{
 
   vm.hides=false
}



  },10)
 
    },
 
 getsearch(){


if(this.searchtext==''){
 return [] 
}
var x=this.allvideos.filter((itm)=>{

  return itm.name.toLowerCase().match(this.searchtext.toLowerCase())
})


return x
 },

 getfolder(){


if(this.searchtext==''){
 return [] 
}
var x=this.leftsides.filter((itm)=>{

  return itm.name.toLowerCase().match(this.searchtext.toLowerCase())
})


return x
 },

 getallusers(){
 

if(Object.keys(this.currentdata).length>0){


  var x=this.currentdata.fullinfo.map((itm)=>{

    return {
      ...itm,
      
    }
  })
  return x.reverse()
 }
 }

  },

   
  methods:{ 

 
    pauseupload(){
      var vm=this

      if(!vm.tasks[vm.tempdocids].status){
       
            vm.task[vm.tempdocids].referpoint.pause()
   
        
      }else{
 
       
      
  
           vm.task[vm.tempdocids].referpoint.resume()



 

      }
 
    },
    getss(){
      return  new Promise(function (resolve, reject) {
setTimeout(()=>{

  resolve(12000)
},3000)
 })
    },
 async getthumb( file, seekTo){
 
    //console.log("getting video cover for file: ", file);
    return new Promise((resolve, reject) => {
        // load the file to a video player
        const videoPlayer = document.createElement('video');
        videoPlayer.setAttribute('src', file);
         
        videoPlayer.load();
        videoPlayer.addEventListener('error', (ex) => {
            reject("error when loading video file", ex);
        });
        // load metadata of the video to get video duration and dimensions
        videoPlayer.addEventListener('loadedmetadata', () => {
            // seek to user defined timestamp (in seconds) if possible
            if (videoPlayer.duration < seekTo) {
                reject("video is too short.");
                return;
            }
            // delay seeking or else 'seeked' event won't fire on Safari
            setTimeout(() => {
              videoPlayer.currentTime = seekTo;
            }, 200);
            // extract video thumbnail once seeking is complete
            videoPlayer.addEventListener('seeked', () => {
                //console.log('video is now paused at %ss.', seekTo);
                // define a canvas to have the same dimension as the video
                const canvas = document.createElement("canvas");
                canvas.width = videoPlayer.videoWidth;
                canvas.height = videoPlayer.videoHeight;
                // draw the video frame to canvas
                const ctx = canvas.getContext("2d");
                ctx.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);
                // return the canvas image as a blob


                    if(canvas.toDataURL('image/jpeg').toString().length>=1048487){
                        resolve(canvas.toDataURL('image/jpeg',0.4)); 
                    }else{
                        resolve(canvas.toDataURL('image/jpeg')); 
                    }

                
              
               
            });
        });
    });
   },
dragme(event)
{
  event.dataTransfer.setData("sourceID", event.target.id);
},

dropHere(ev)
{

 ev.preventDefault();
 

  if (ev.dataTransfer.items) {
    // Use DataTransferItemList interface to access the file(s)
    for (var i = 0; i < ev.dataTransfer.items.length; i++) {
      // If dropped items aren't files, reject them
      if (ev.dataTransfer.items[i].kind === 'file') {
        var file = ev.dataTransfer.items[i].getAsFile();

        //console.log('file')

        this.readfiledrop(file)
         
      }
    }
  } 
},

dropOver(event)
{ 

  //console.log ("inside drop Over.."+event);
},
allowDrop(ev) {
    ev.preventDefault();
},
    remmem(item){
this.tempitm={
  ...item
}
this.rmbox=true
    },
    rmconf(){



 

var members=this.currentdata.members.filter((itm)=>{
  return itm.email!=this.tempitm.email
})

 var users=this.currentdata.users.filter((itm)=>{
  return itm!=this.tempitm.email
})
 

var fullinfo=this.currentdata.fullinfo.filter((itm)=>{
  return itm.email!=this.tempitm.email
})

fb.db.collection("wlframeprojects").doc(this.currentdata.ids).update({
  members:[...members],
  users:[...users],
  fullinfo:[...fullinfo],  
}).then(()=>{
  this.tempitm={
 
}
this.rmbox=false
})


 
    },

invitemem(){
 
if(this.invtext.includes('@')){
 
var msm=this.currentdata.members.filter((itm)=>{
  return itm.email==this.invtext
})



 if(msm.length==0){
 

 fb.db.collection('wlframeprojects').doc(this.currentdata.ids).update({
members:[
...this.currentdata.members,
{
  email:this.invtext ,
            active:false,
            memberinfo:{
             
            }
}
]
 }).then(()=>{

  var x={
 link:"https://form.wl.team/frameio?invite="+this.cdocid,
proname:this.currentdata.name,
to:this.invtext,
username:this.userinfo.name,

  }
  var xs='https://us-central1-staging-wlshop.cloudfunctions.net/sendinvitemail?link='+x.link+'&proname='+x.proname+'&to='+x.to+'&username='+x.username
  //console.log(xs)
  this.invtext=''
  const options = {
  url: 'https://us-central1-staging-wlshop.cloudfunctions.net/sendinvitemail?link='+x.link+'&proname='+x.proname+'&to='+x.to+'&username='+x.username,
  method: 'GET',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json;charset=UTF-8'
  },
  
};

axios(options)
  .then(response => {
 
  
//console.log(response)

  });




 })

}else{

  this.invtext=''
}
}
},
    lout(){
fb.auth.signOut().then(()=>{
            this.$router.replace({path:'/login'})

})
    },
setaddpro(){

this.addboxproject=true
setTimeout(()=>{
document.getElementById('addpros').focus()

},10)
},
rendermins(date){
if(Number(date)>3600){
 var hours = Math.floor(date / 60 / 60);
  var seconds = Math.floor(date % 60)
  var hr= hours.toString().length==1?'0'+hours:hours

var mn= (Math.floor(date / 60) - (hours * 60)).toString().length==1?'0'+(Math.floor(date / 60) - (hours * 60)):(Math.floor(date / 60) - (hours * 60))
var sc= seconds.toString().length==1?'0'+seconds:seconds
return  hr+':'+mn+':'+sc
}else{

 var hours = Math.floor(date / 60 / 60);
  var seconds = Math.floor(date % 60)
var mn= (Math.floor(date / 60) - (hours * 60)).toString().length==1?'0'+(Math.floor(date / 60) - (hours * 60)):(Math.floor(date / 60) - (hours * 60))
var sc= seconds.toString().length==1?'0'+seconds:seconds
return  mn+':'+sc

}

},
renderdates(itm){
 
var mon=Number(itm.date.split(':')[1])-1

var cdate=new Date(itm.date.split(':')[2],mon,itm.date.split(':')[0])


var yesdate=new Date()
yesdate.setDate(yesdate.getDate()-1)

var ysstring=yesdate.getDate()+'/'+yesdate.getMonth()+'/'+yesdate.getFullYear()
var cstr=cdate.getDate()+'/'+cdate.getMonth()+'/'+cdate.getFullYear()
//console.log(ysstring+'--'+cstr)

if(ysstring==cstr){

  return 'Yesterday'
 
}else{
  return itm.strdate
}
},
 tests(){
 



},


    levpro(){

 


           var users=this.tempdata.users.filter((itm)=>{
            return itm!=fb.auth.currentUser.email
           })
           var fullinfo=this.tempdata.fullinfo.filter((itm)=>{
            return itm.email!=fb.auth.currentUser.email
           })

           var x=this.leftsides.filter((itm,index)=>{
            return index!=0
           })
 
if(x.length>0){
  this.cdocid=x[0].ids

  window.localStorage.setItem('cdoc',x[0].ids)
}else{
  this.currentdata={}
}
 

 if(this.leftsides.length==1){
this.currentdata={}
this.allvideos=[]
this.cdocid=''
       }



 fb.db.collection('wlframeprojects').doc(this.tempdata.ids).update({
  users,
  fullinfo
 }).then(()=>{
 
 
this.tempdata={
 
}
  this.levbox=false
  
  this.proname=''

 })
    },

    setlevpro(item){
item.selectedright=false
 
this.tempdata={
  ...item
}
  this.levbox=true
  
  this.proname=item.name
    },
    delpro(){
       window.localStorage.removeItem('cdoc')
       if(this.leftsides.length==1){
this.currentdata={}
this.allvideos=[]
this.cdocid=''
       }
 fb.db.collection('wlframeprojects').doc(this.tempdata.ids).delete().then(()=>{
            this.tempdata={}
  this.delbox=false
 


 
           })
    },
    setdelpro(item){
item.selectedright=false
 
this.tempdata={
  ...item
}
  this.delbox=true
  

 },
    editproject(){

           fb.db.collection('wlframeprojects').doc(this.tempdata.ids).update({
            name:this.projectnames
           }).then(()=>{
            this.tempdata={
 
}
  this.editprobox=false
  this.projectnames=''
           })

    },
 seteditpro(item){
item.selectedright=false
 
this.tempdata={
  ...item
}
  this.editprobox=true
  this.projectnames=item.name

 },
  async getactdata(){
     return new Promise( function (resolve, reject) {
var docRef =  fb.db.collection("wlframeusers").doc(fb.auth.currentUser.uid);

docRef.get().then((doc) => {
    if (doc.exists) {
        //console.log("Document data:", doc.data());
   resolve(doc.data())
 } 
}).catch((error) => {
    //console.log("Error getting document:", error);
});

})
},

addteammem(itm){

//console.log(itm)

 var vm=this
var fullinfo=[
...this.currentdata.fullinfo,
 
itm.memberinfo
 ]


var members=[
...this.currentdata.members,
 
itm
 ]
 

var users=[
...this.currentdata.users,
 
itm.email
 ]
 


 console.log({ 
  users: users,
  fullinfo:fullinfo,
  members:members 
  })

fb.db.collection("wlframeprojects").doc(this.currentdata.ids).update({ 
  users: users,
  fullinfo:fullinfo,
  members:members 
  }).then(()=>{
    vm.invtext=''

  })

},
   async getinvite(){
  


var vm=this

var userdata=await this.getactdata()
 return new Promise( function (resolve, reject) {

 var sfDocRef = fb.db.collection("wlframeprojects").doc(vm.$route.query.invite)
 

return fb.db.runTransaction((transaction) => {
     return transaction.get(sfDocRef).then((sfDoc) => {
        if (!sfDoc.exists) {
            throw "Document does not exist!";
        } 

 
       

var x=sfDoc.data().members.filter((itm)=>{
  return itm.email==fb.auth.currentUser.email
})

if(x.length>0){

if(!x[0].active){


 
var fullinfo=[
...sfDoc.data().fullinfo,
 
 userdata
 ]

var members=sfDoc.data().members.map((itms)=>{
  if(itms.email==fb.auth.currentUser.email){
    return{
      ...itms,
      active:true,
            memberinfo:{
             ...userdata
            }
    }
  }else{
    return itms
  }
})


var users=[
...sfDoc.data().users,
 
fb.auth.currentUser.email
 ]
 
 


var memberss=members.filter((itms)=>{
   return itms.email==fb.auth.currentUser.email
})
 transaction.update(sfDocRef, { users: users,fullinfo:fullinfo,members:members });


fb.db.collection("wlframemainaccount").add({
...memberss[0]
})


vm.cdocid=sfDoc.id
}else{


 

}
}else{


}

    });
}).then(() => {
    //resolve('s')
   vm.acceptlink=true
        setTimeout(()=>{
          vm.acceptlink=false

          vm.$router.replace({path:'/frameio'})
        },3000)
 
        
}).catch((error) => {
    //console.log("Transaction failed: ", error);
});

 })

},
    copylinks(){

        this.copylink=true
        setTimeout(()=>{
          this.copylink=false
        },3000)
navigator.clipboard.writeText("http://localhost:8080/frameio?invite="+this.cdocid);
    },
nullfile(event){
event.target.value=null
},
    getdatas(data){

this.localloader=true
      //console.log(data)
this.allvideos=[]
      var vm=this
      vm.tempdocids=data.ids
      this.searchtext=''
this.cdocid=data.ids
       vm.currentdata={
                      ...data,

      }

 

       var x=this.leftsides.map((itm)=>{

        if(itm.ids==data.ids){
          return {
            ...itm,
            selected:true
          }
        }else{
          return {
            ...itm,
            selected:false
          }
        }
      })

      this.leftsides=[
      ...x
      ]
var allvideos=[]


window.localStorage.setItem('cdoc',this.cdocid)
var docRef = fb.db.collection("wlframeprojects").doc(this.cdocid).collection('videos').orderBy("cdate",'desc').get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          
            //console.log(doc.id, " => ", doc.data());

            allvideos.push({...doc.data(),ids:doc.id})
        });

        vm.allvideos=[
        ...allvideos
        ]
        vm.localloader=false

    })
    .catch((error) => {
        //console.log("Error getting documents: ", error);
    });

  },
 async readfile(event,id){
 
 var vm=this
 var cdocid=vm.cdocid
  this.tempdocids=cdocid
 this.tempdocid.push(cdocid)
 this.fileuplaod=true
 //console.log(event.target.files[0])

//console.log(event.target.files[0].type)

if(event.target.files[0].type.split('/')[0]=='audio'){





 




//console.log(event.target.files[0].size)
 var resimg=await this.uploadImageAsPromisearticleimage(event.target.files[0],cdocid) 

 
setTimeout(()=>{
//console.log(event)

},3000)
//console.log(event.target.files[0].size)
 var bytes=event.target.files[0].size
 var name=event.target.files[0].name
 //console.log(event)
  var uploader={
  ...vm.userinfo
 }
if (bytes >= 1073741824) {  // 1024 * 1024 * 1024
    bytes = (bytes / 1073741824) + ' GB';

  } else if (bytes >= 1048576) { // 1024 * 1024
    bytes = (bytes / 1048576) + ' MB';

  } else if (bytes >= 1024) { // 1024 * 1
    bytes = (bytes / 1024) + ' KB';

  } else if (bytes > 1) {
    bytes = bytes + ' bytes';

  } else if ($bytes == 1) {
    bytes = bytes + ' byte';

  } else {
    bytes = '0 bytes';
  }


var x=vm.leftsides.filter((itm)=>{
  return itm.ids==resimg.docid
})


 var video = document.createElement('audio');
  video.preload = 'metadata';

  video.onloadedmetadata = async function() {
    window.URL.revokeObjectURL(video.src);
    var duration = video.duration;

var thumb='https://firebasestorage.googleapis.com/v0/b/staging-wlshop.appspot.com/o/Untitled%20design%20(1).png?alt=media&token=1decdb99-af63-4817-9cba-1541d9c9fcbd'
 
var cdate=new Date()
    var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun",
"Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

var dates=cdate.getDate().toString().length==1?'0'+cdate.getDate():cdate.getDate()
var strdate=dates+' '+monthNames[cdate.getMonth()]+' '+cdate.getFullYear()
 
var xx={
    name,
      video:resimg.downloadURL,
      bytes,
      thumb,
      uploader:{
        ...uploader},
      duration,
      cdocid:resimg.docid,
      viewedby:[],
      cdoc:{...x[0]},
      date:new Date().getDate()+':'+(new Date().getMonth()+1)+':'+new Date().getFullYear(),
      time:new Date().getHours()+':'+new Date().getMinutes(),
      status:0,
      comments:[],
      commentcount:0,
      defaultimg:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5QEJ1jr1Hlnzj_fyf6BlreyyoaN7zcpaiwA&usqp=CAU',
      strdate:strdate,
      cdate:new Date(),
      type:'audio',
      counts:vm.allvideos.length+1
}

     fb.db.collection('wlframeprojects').doc(resimg.docid).collection('videos').add({
    ...xx
     }).then((docref)=>{

 var yy={
  ...xx,
  ids:docref.id
 }
  
  

vm.tempdocid=vm.tempdocid.filter((itms)=>{
  return itms!=resimg.docid
})

if(vm.currentdata.ids==resimg.docid){
        vm.allvideos=[
        yy,
        ...vm.allvideos
        ]
        vm.fileuplaod=false

}
       

    


     })
   
  }

  video.src = URL.createObjectURL(event.target.files[0]);;














}
else if(event.target.files[0].type.split('/')[0]=='image'){
  

















//console.log(event.target.files[0].size)
 var resimg=await this.uploadImageAsPromisearticleimage(event.target.files[0],cdocid) 

 
//console.log(event.target.files[0].size)
 var bytes=event.target.files[0].size
 var name=event.target.files[0].name
 //console.log(event)
  var uploader={
  ...vm.userinfo
 }
if (bytes >= 1073741824) {  // 1024 * 1024 * 1024
    bytes = (bytes / 1073741824) + ' GB';

  } else if (bytes >= 1048576) { // 1024 * 1024
    bytes = (bytes / 1048576) + ' MB';

  } else if (bytes >= 1024) { // 1024 * 1
    bytes = (bytes / 1024) + ' KB';

  } else if (bytes > 1) {
    bytes = bytes + ' bytes';

  } else if ($bytes == 1) {
    bytes = bytes + ' byte';

  } else {
    bytes = '0 bytes';
  }


var x=vm.leftsides.filter((itm)=>{
  return itm.ids==resimg.docid
})


 
 
 

var thumb=resimg.downloadURL
 
var cdate=new Date()
    var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun",
"Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

var dates=cdate.getDate().toString().length==1?'0'+cdate.getDate():cdate.getDate()
var strdate=dates+' '+monthNames[cdate.getMonth()]+' '+cdate.getFullYear()
 
var xx={
    name,
      video:resimg.downloadURL,
      bytes,
      thumb,
      uploader:{
        ...uploader},
      duration:'0:0',
      cdocid:resimg.docid,
      viewedby:[],
      cdoc:{...x[0]},
      date:new Date().getDate()+':'+(new Date().getMonth()+1)+':'+new Date().getFullYear(),
      time:new Date().getHours()+':'+new Date().getMinutes(),
      status:0,
      comments:[],
      commentcount:0,
      defaultimg:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5QEJ1jr1Hlnzj_fyf6BlreyyoaN7zcpaiwA&usqp=CAU',
      strdate:strdate,
      cdate:new Date(),
      type:'image',
        counts:vm.allvideos.length+1
}

     fb.db.collection('wlframeprojects').doc(resimg.docid).collection('videos').add({
    ...xx
     }).then((docref)=>{

 var yy={
  ...xx,
  ids:docref.id
 }
  
  

vm.tempdocid=vm.tempdocid.filter((itms)=>{
  return itms!=resimg.docid
})

if(vm.currentdata.ids==resimg.docid){
        vm.allvideos=[
        yy,
        ...vm.allvideos
        ]
        vm.fileuplaod=false

}
       
  const formData = new FormData();
     formData.append("files", event.target.files[0]); 
     for (var pair of formData.entries()) {
    //console.log(pair[0]+ ', ' + pair[1]); 
}
 

    


     })
   
 

 





















}
else if(event.target.files[0].type.split('/')[0]=='video'){
  

 //console.log(event.target.files[0])
//console.log(event.target.files[0].size)
 var resimg=await this.uploadImageAsPromisearticleimage(event.target.files[0],cdocid) 

 
setTimeout(()=>{
//console.log(event)

},3000)
//console.log(event.target.files[0].size)
 var bytes=event.target.files[0].size
 var name=event.target.files[0].name
 
 var names=name.split('.')
 
 //console.log(names)
 var ext=names[names.length-1]
 
 var filename=names.join('.').replace(/[^a-z]/gi, '').toLowerCase()
 var finalfilename=filename+'_s.vtt'
 
 var translink='https://www.nextjs.getsitewp.com:5000/statics/'+finalfilename

 //console.log(event)
  var uploader={
  ...vm.userinfo
 }
if (bytes >= 1073741824) {  // 1024 * 1024 * 1024
    bytes = (bytes / 1073741824) + ' GB';

  } else if (bytes >= 1048576) { // 1024 * 1024
    bytes = (bytes / 1048576) + ' MB';

  } else if (bytes >= 1024) { // 1024 * 1
    bytes = (bytes / 1024) + ' KB';

  } else if (bytes > 1) {
    bytes = bytes + ' bytes';

  } else if ($bytes == 1) {
    bytes = bytes + ' byte';

  } else {
    bytes = '0 bytes';
  }


var x=vm.leftsides.filter((itm)=>{
  return itm.ids==resimg.docid
})


 var video = document.createElement('video');
  video.preload = 'metadata';

  video.onloadedmetadata = async function() {
    window.URL.revokeObjectURL(video.src);
    var duration = video.duration;

var thumb=await vm.getthumb(video.src, 0.10)

//console.log('s')
 
//console.log(thumb)
var cdate=new Date()
    var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun",
"Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

var dates=cdate.getDate().toString().length==1?'0'+cdate.getDate():cdate.getDate()
var strdate=dates+' '+monthNames[cdate.getMonth()]+' '+cdate.getFullYear()
 
var xx={
    name,
      video:resimg.downloadURL,
      bytes,
      thumb,
      uploader:{
        ...uploader},
      duration,
      previewlink:translink,
      cdocid:resimg.docid,
      viewedby:[],
      cdoc:{...x[0]},
      date:new Date().getDate()+':'+(new Date().getMonth()+1)+':'+new Date().getFullYear(),
      time:new Date().getHours()+':'+new Date().getMinutes(),
      status:0,
      comments:[],
      commentcount:0,
      defaultimg:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5QEJ1jr1Hlnzj_fyf6BlreyyoaN7zcpaiwA&usqp=CAU',
      strdate:strdate,
      cdate:new Date(),
       type:'video',
         counts:vm.allvideos.length+1
}
 
     fb.db.collection('wlframeprojects').doc(resimg.docid).collection('videos').add({
    ...xx
     }).then((docref)=>{

 var yy={
  ...xx,
  ids:docref.id
 }
  
  

vm.tempdocid=vm.tempdocid.filter((itms)=>{
  return itms!=resimg.docid
})

if(vm.currentdata.ids==resimg.docid){
        vm.allvideos=[
        yy,
        ...vm.allvideos
        ]
        vm.fileuplaod=false

}
        
 
  const formData = new FormData();
  
       formData.append("duration", duration); 

     formData.append("files", event.target.files[0]); 
     for (var pair of formData.entries()) {
    //console.log(pair[0]+ ', ' + pair[1]); 
}
    fetch("https://nextjs.getsitewp.com:5000/upload_files", {
        method: 'POST',
        body: formData,
        headers: {
           
        }
    })
        .then((res) =>  console.log(res))
        .catch((err) => ("Error occured", err));



    


     })
   
  }

  video.src = URL.createObjectURL(event.target.files[0]);;



 }





},

 async readfiledrop(file){


 
 var vm=this
 var cdocid=vm.cdocid
  this.tempdocids=cdocid
 this.tempdocid.push(cdocid)
 this.fileuplaod=true
 
 
 if(file.type.split('/')[0]=='audio'){






 
 var resimg=await this.uploadImageAsPromisearticleimage(file,cdocid) 

 
 
  var bytes=file.size
 var name=file.name
   var uploader={
  ...vm.userinfo
 }
if (bytes >= 1073741824) {  // 1024 * 1024 * 1024
    bytes = (bytes / 1073741824) + ' GB';

  } else if (bytes >= 1048576) { // 1024 * 1024
    bytes = (bytes / 1048576) + ' MB';

  } else if (bytes >= 1024) { // 1024 * 1
    bytes = (bytes / 1024) + ' KB';

  } else if (bytes > 1) {
    bytes = bytes + ' bytes';

  } else if ($bytes == 1) {
    bytes = bytes + ' byte';

  } else {
    bytes = '0 bytes';
  }


var x=vm.leftsides.filter((itm)=>{
  return itm.ids==resimg.docid
})


 var video = document.createElement('audio');
  video.preload = 'metadata';

  video.onloadedmetadata = async function() {
    window.URL.revokeObjectURL(video.src);
    var duration = video.duration;

var thumb='https://firebasestorage.googleapis.com/v0/b/staging-wlshop.appspot.com/o/Untitled%20design%20(1).png?alt=media&token=1decdb99-af63-4817-9cba-1541d9c9fcbd'
 
var cdate=new Date()
    var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun",
"Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

var dates=cdate.getDate().toString().length==1?'0'+cdate.getDate():cdate.getDate()
var strdate=dates+' '+monthNames[cdate.getMonth()]+' '+cdate.getFullYear()
 
var xx={
    name,
      video:resimg.downloadURL,
      bytes,
      thumb,
      uploader:{
        ...uploader},
      duration,
      cdocid:resimg.docid,
      viewedby:[],
      cdoc:{...x[0]},
      date:new Date().getDate()+':'+(new Date().getMonth()+1)+':'+new Date().getFullYear(),
      time:new Date().getHours()+':'+new Date().getMinutes(),
      status:0,
      comments:[],
      commentcount:0,
      defaultimg:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5QEJ1jr1Hlnzj_fyf6BlreyyoaN7zcpaiwA&usqp=CAU',
      strdate:strdate,
      cdate:new Date(),
      type:'audio',
        counts:vm.allvideos.length+1
}

     fb.db.collection('wlframeprojects').doc(resimg.docid).collection('videos').add({
    ...xx
     }).then((docref)=>{

 var yy={
  ...xx,
  ids:docref.id
 }
  
  

vm.tempdocid=vm.tempdocid.filter((itms)=>{
  return itms!=resimg.docid
})

if(vm.currentdata.ids==resimg.docid){
        vm.allvideos=[
        yy,
        ...vm.allvideos
        ]
        vm.fileuplaod=false

}
       

    


     })
   
  }

  video.src = URL.createObjectURL(file);;
 


 }
 else  if(file.type.split('/')[0]=='image'){



/*
exec("mtn -i -t -v -P -s 60 .jpg file.ext 2>&1 ./uploads/", (error, stdout, stderr) => {
    if (error) {
        //console.log(`error: ${error.message}`);
        return;
    }
    if (stderr) {
        //console.log(`stderr: ${stderr}`);
        return;
    }
    //console.log(`stdout: ${stdout}`);
});

*/




  var resimg=await this.uploadImageAsPromisearticleimage(file,cdocid) 

 
 
 var bytes=file.size
 var name=file.name
   var uploader={
  ...vm.userinfo
 }
if (bytes >= 1073741824) {  // 1024 * 1024 * 1024
    bytes = (bytes / 1073741824) + ' GB';

  } else if (bytes >= 1048576) { // 1024 * 1024
    bytes = (bytes / 1048576) + ' MB';

  } else if (bytes >= 1024) { // 1024 * 1
    bytes = (bytes / 1024) + ' KB';

  } else if (bytes > 1) {
    bytes = bytes + ' bytes';

  } else if ($bytes == 1) {
    bytes = bytes + ' byte';

  } else {
    bytes = '0 bytes';
  }


var x=vm.leftsides.filter((itm)=>{
  return itm.ids==resimg.docid
})


 
 
 

var thumb=resimg.downloadURL
 
var cdate=new Date()
    var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun",
"Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

var dates=cdate.getDate().toString().length==1?'0'+cdate.getDate():cdate.getDate()
var strdate=dates+' '+monthNames[cdate.getMonth()]+' '+cdate.getFullYear()
 
var xx={
    name,
      video:resimg.downloadURL,
      bytes,
      thumb,
      uploader:{
        ...uploader},
      duration:'0:0',
      cdocid:resimg.docid,
      viewedby:[],
      cdoc:{...x[0]},
      date:new Date().getDate()+':'+(new Date().getMonth()+1)+':'+new Date().getFullYear(),
      time:new Date().getHours()+':'+new Date().getMinutes(),
      status:0,
      comments:[],
      commentcount:0,
      defaultimg:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5QEJ1jr1Hlnzj_fyf6BlreyyoaN7zcpaiwA&usqp=CAU',
      strdate:strdate,
      cdate:new Date(),
        counts:vm.allvideos.length+1,
      type:'image'
}

     fb.db.collection('wlframeprojects').doc(resimg.docid).collection('videos').add({
    ...xx
     }).then((docref)=>{

 var yy={
  ...xx,
  ids:docref.id
 }
  
  

vm.tempdocid=vm.tempdocid.filter((itms)=>{
  return itms!=resimg.docid
})

if(vm.currentdata.ids==resimg.docid){
        vm.allvideos=[
        yy,
        ...vm.allvideos
        ]
        vm.fileuplaod=false

}
       

    


     })
   
 

 



 }

 else if(file.type.split('/')[0]=='video'){





 
 
 var resimg=await this.uploadImageAsPromisearticleimage(file,cdocid) 

 
 var bytes=file.size
 var name=file.name


 var names=name.split('.')
 
 //console.log(names)
 var ext=names[names.length-1]
 
 var filename=names.join('.').replace(/[^a-z]/gi, '').toLowerCase()
 var finalfilename=filename+'_s.vtt'
 
 var translink='https://www.nextjs.getsitewp.com:5000/statics/'+finalfilename



   var uploader={
  ...vm.userinfo
 }
if (bytes >= 1073741824) {  // 1024 * 1024 * 1024
    bytes = (bytes / 1073741824) + ' GB';

  } else if (bytes >= 1048576) { // 1024 * 1024
    bytes = (bytes / 1048576) + ' MB';

  } else if (bytes >= 1024) { // 1024 * 1
    bytes = (bytes / 1024) + ' KB';

  } else if (bytes > 1) {
    bytes = bytes + ' bytes';

  } else if ($bytes == 1) {
    bytes = bytes + ' byte';

  } else {
    bytes = '0 bytes';
  }


var x=vm.leftsides.filter((itm)=>{
  return itm.ids==resimg.docid
})


 var video = document.createElement('video');
  video.preload = 'metadata';

  video.onloadedmetadata = async function() {
    window.URL.revokeObjectURL(video.src);
    var duration = video.duration;

var thumb=await vm.getthumb(video.src, 0.10)

//console.log('s')

//console.log(thumb)
var cdate=new Date()
    var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun",
"Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

var dates=cdate.getDate().toString().length==1?'0'+cdate.getDate():cdate.getDate()
var strdate=dates+' '+monthNames[cdate.getMonth()]+' '+cdate.getFullYear()
 
var xx={
    name,
      video:resimg.downloadURL,
      bytes,
      thumb,
      uploader:{
        ...uploader},
      duration,
      cdocid:resimg.docid,
      previewlink:translink,
      viewedby:[],
      cdoc:{...x[0]},
      date:new Date().getDate()+':'+(new Date().getMonth()+1)+':'+new Date().getFullYear(),
      time:new Date().getHours()+':'+new Date().getMinutes(),
      status:0,
      comments:[],
      commentcount:0,
      defaultimg:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5QEJ1jr1Hlnzj_fyf6BlreyyoaN7zcpaiwA&usqp=CAU',
      strdate:strdate,
      cdate:new Date(),
       type:'video',
         counts:vm.allvideos.length+1
}

     fb.db.collection('wlframeprojects').doc(resimg.docid).collection('videos').add({
    ...xx
     }).then((docref)=>{

 var yy={
  ...xx,
  ids:docref.id
 }
  
  

vm.tempdocid=vm.tempdocid.filter((itms)=>{
  return itms!=resimg.docid
})

if(vm.currentdata.ids==resimg.docid){
        vm.allvideos=[
        yy,
        ...vm.allvideos
        ]
        vm.fileuplaod=false

}
         const formData = new FormData();
  
       formData.append("duration", duration); 

     formData.append("files", event.target.files[0]); 
     for (var pair of formData.entries()) {
    //console.log(pair[0]+ ', ' + pair[1]); 
}
    fetch("https://nextjs.getsitewp.com:5000/upload_files", {
        method: 'POST',
        body: formData,
        headers: {
           
        }
    })
        .then((res) =>  console.log(res))
        .catch((err) => ("Error occured", err));


    


     })
   
  }

  video.src = URL.createObjectURL(file);;



 }
 

 
},



 async uploadImageAsPromisearticleimage (file,docid) {
  var vm=this
    return new Promise(function (resolve, reject) {

 vm.task[docid]={
 
 }
  vm.tasks[docid]={
  status:false
 }

    vm.task[docid].referpoint=fb.storage.ref('videos/'+file.name).put(file);
        

        //Update progress bar
        vm.task[docid].referpoint.on('state_changed',
            function progress(snapshot){
            
              var pt=(snapshot.bytesTransferred/snapshot.totalBytes)*100;

                    if(vm.tempdocids==docid){
 
                    // vm.currentdata.percentage=Math.round(pt)+'%'

 }


 if(snapshot.state=='paused'){

 
var x={
  ...vm.tasks
}

  x[docid].status=true
  x[docid].percentage=Math.round(pt)+'%'

 vm.tasks={
  ...x
 }


 
 }else {
var x={
  ...vm.tasks
}

   x[docid].status=false
   x[docid].percentage=Math.round(pt)+'%'

 vm.tasks={
  ...x
 }


 

 }

                   
 
 console.log(vm.tasks)
      
            },
    
            function error(err){
             
                //console.log(err);
                reject(err);
            },
            async function complete (){
               
               
                var downloadURL =await vm.task[docid].referpoint.snapshot.ref.getDownloadURL()
              
                resolve({downloadURL,docid});
            }
        );
    });
},
 
    addproject(){
 this.loadstarted=true
 var x=Math.round(Math.random()*100000000000)
  window.localStorage.setItem('cdoc',x.toString())
       fb.db.collection('wlframeprojects').doc(x.toString()).set({

          
          name:this.projectname,
          createdby:{
            ...this.userinfo
          },
          users:[ 
            fb.auth.currentUser.email
           ],
           members:[ 
          {
            email:fb.auth.currentUser.email,
            active:true,
            memberinfo:{
              ...this.userinfo
            }
          }
            
           ],
           fullinfo:[{
            ...this.userinfo
           }],
           createdon:new Date(),


       
    
      }).then(()=>{

       

 
        this.projectname=''
        this.addboxproject=false
        this.loadstarted=false
      })


    }
   
}
 

   
   
    
 
  
}
</script>
<style scoped >
 
</style>
 



// WEBPACK FOOTER //
// src/components/frameio.vue